import React, { useRef, useState, useEffect, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Container,
  Grid,
  Popover,
  Button,
  InputLabel,
  FormControl,
  FormHelperText,
  Input,
  Typography,
  FormControlLabel,
  Checkbox,
  Modal,
  Box,
  Select,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  ListItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
  List,
  IconButton,
} from "@material-ui/core";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import { toast } from "react-toastify";
import {
  createInvoiceDetails,
  getModelSerialList,
  getBillShipContactList,
  checkContactInDB,
  getNewModelSerialList,
  getInvoiceNewContactList,
  getMemoList,
  getInvoiceSetting,
  dataTransferBusinessList,
  invoiceDataPush,
  // createQboInvoice,
} from "../actions/dashboardAction";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import imageNotAvailable from "../../../../assests/images/img-soon.png";
import "../style/style.css";
import Header from "../../../../common/components/Header";
import FooterComponent from "../../../../common/components/Footer";
import { useHistory, useLocation } from "react-router-dom";
import {
  Popover as AntdPopover,
  Input as AntdInput,
  Modal as AntdModal,
} from "antd";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DateFnsUtils from "@date-io/date-fns";
import PropTypes from "prop-types";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import "../../../../common/style/SearchBar.css";
// import {formatPhoneNumber, unformatPhoneNumber} from "../../../../common/components/Helper/Utils";
import { SpinnerRoundFilled } from "spinners-react";
import getUserdetailsforsubscrption from "../../dashboard/actions/dashboardaapi";
import ContactListModal from "./ContactListModal";
import CreateContactDialog from "./CreateContactDialog";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Pricewarining from "./Pricewarining";
import _, { set } from "lodash";
import { event } from "jquery";
import { isValid } from "date-fns";
import { Autocomplete } from "@material-ui/lab";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import InvoiceValidation from "../../common/components/InvoiceValidation";
import QboInvoice from "./QboInvoice";
import ClearIcon from "@material-ui/icons/Clear";
import { searchProductsAPI } from "../../dealer/actions/dealerAction";
import { getDealerContactMapping } from "./dealerContactMapping";
import {
  formatDate,
  showErrorToast,
  isTwoAddressSame,
  showSuccessToast,
} from "../../../../common/components/Helper/Utils";

const getFirstImageUrl = (images) => {
  if (!images) return null;
  if (Array.isArray(images)) return images[0] || null;
  if (typeof images === "string") return images.split(",")[0]?.trim() || null;
  return null;
};

const getInventoryDisplayImage = (item) => {
  const misc = {
    ...(item?.miscimages || {}),
    ...(item?.imagepaths || {}),
  };
  return (
    misc.front ||
    misc.back ||
    misc.left ||
    misc.right ||
    misc.wrist_shot ||
    misc.buckle_closed ||
    misc.buckle_opened ||
    misc.free_form ||
    getFirstImageUrl(misc.images) ||
    getFirstImageUrl(item?.product_imagepaths?.images) ||
    imageNotAvailable
  );
};

const getInventoryProductName = (val) => {
  if (!val) return "";
  const technicalTitle =
    val?.technical_details?.product_title ||
    val?.technical_details?.product_name ||
    "";
  return (
    val?.inventory_title ||
    val?.modelname ||
    val?.description ||
    technicalTitle ||
    val?.model ||
    ""
  );
};

const { innerWidth: width, innerHeight: height } = window;

const invoiceObj = [
  {
    id: "modelAndSerial",
    label: "Search Model | Serial No | Inventory ID",
    minWidth: 100,
    type: "search",
    required: true,
    errMsg: "Please Enter Model | Serial No | Inventory ID",
  },
  {
    id: "modelNumber",
    label: "Model",
    minWidth: 100,
    type: "search",
    required: false,
    errMsg: "Please Enter Model",
  },
  { id: "image", label: "Image", minWidth: 80, type: "image", required: false },
  {
    id: "serialNumber",
    label: "Serial No",
    minWidth: 80,
    type: "search",
    required: false,
    errMsg: "Please Enter Serial No",
  },
  {
    id: "productName",
    label: "Product Name",
    minWidth: 140,
    type: "text",
    required: false,
  },
  {
    id: "quantity",
    label: "Qty",
    minWidth: 80,
    type: "number",
    required: true,
    errMsg: "Please enter quantity",
  },
  {
    id: "currency",
    label: "Currency",
    minWidth: 30,
    type: "select",
    required: true,
    errMsg: "Please enter rate",
  },
  {
    id: "amount",
    label: "Amount",
    minWidth: 65,
    type: "amount",
    required: true,
    errMsg: "Please Enter Amount",
  },
  { id: "action", label: "Action", minWidth: 70, align: "center" },
];

const billingAddress = [
  {
    id: "billingToName",
    label: "Contact Name",
    minWidth: 80,
    type: "text_search",
    required: true,
    errMsg: "Please enter contact name",
  },
  {
    id: "billingSearchType",
    label: "Search By",
    minWidth: 80,
    type: "search_type_dropdown",
    required: false,
    errMsg: "",
  },
  {
    id: "billingToBusinessName",
    label: "Business Name",
    minWidth: 80,
    type: "text",
    required: true,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToPhoneNo",
    label: "",
    minWidth: 80,
    type: "phone",
    required: true,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToEmail",
    label: "Email",
    minWidth: 80,
    type: "email",
    required: true,
    errMsg: "Please enter valid email",
    isDisabled: true,
  },
  {
    id: "billingToAddressLine1",
    label: "Address Line1",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToAddressLine2",
    label: "Address Line2",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToCity",
    label: "City",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToCountry",
    label: "Country",
    minWidth: 80,
    type: "select",
    value: "United States",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToState",
    label: "State",
    minWidth: 80,
    type: "select",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "billingToZip",
    label: "Zipcode",
    minWidth: 80,
    type: "number",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
];

const shippingAddress = [
  {
    id: "shippingToName",
    label: "Contact Name",
    minWidth: 80,
    type: "text_search",
    required: true,
    errMsg: "Please enter contact name",
  },
  {
    id: "shippingSearchType",
    label: "Search By",
    minWidth: 80,
    type: "search_type_dropdown",
    required: false,
    errMsg: "",
  },
  {
    id: "shippingToBusinessName",
    label: "Business Name",
    minWidth: 80,
    type: "text",
    required: true,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToPhoneNo",
    label: "",
    minWidth: 80,
    type: "phone",
    required: true,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToEmail",
    label: "Email",
    minWidth: 80,
    type: "email",
    required: true,
    errMsg: "Please enter valid email",
    isDisabled: true,
  },
  {
    id: "shippingToAddressLine1",
    label: "Address Line1",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToAddressLine2",
    label: "Address Line2",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToCity",
    label: "City",
    minWidth: 80,
    type: "text",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToCountry",
    label: "Country",
    minWidth: 80,
    type: "select",
    value: "United States",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToState",
    label: "State",
    minWidth: 80,
    type: "select",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
  {
    id: "shippingToZip",
    label: "Zipcode",
    minWidth: 80,
    type: "number",
    required: false,
    errMsg: "",
    isDisabled: true,
  },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

function CreateInvoiceComponent(props) {
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
    reset,
    control,
    clearErrors,
    setError,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    setValue: setValue1,
    getValues: getValues1,
    formState: { errors: errors1 },
    watch: watch1,
    reset: reset1,
    setFocus: setFocus1,
    clearErrors: clearErrors1,
  } = useForm({
    defaultValues: {
      terms: "Immediate",
    },
  });
  const accountId = window.sessionStorage.getItem("accountId");
  const history = useHistory();
  const inputRef = useRef(null);
  const shipinputRef = useRef(null);
  const modelinputRef = useRef(null);
  const serialinputRef = useRef(null);
  const [dataset, setdataset] = useState([]);
  const [paymentContactBased, setPaymentContactBased] = useState([]);
  const [shippingdataset, setshippingdataset] = useState([]);
  const [rows, setRows] = useState([]);
  const [openModal, setModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [isSameAddress, setSameAddress] = useState(false);
  const [isOnetimeShippingAddress, setIsOnetimeShippingAddress] = useState(false);
  const [amount, setAmount] = useState(null);
  const [shippingDate, setShippingDate] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState(null);
  const [notes, setNotes] = useState(null);
  const [wireDetails, setWireDetails] = useState(true);
  const [zelleDetails, setZelleDetails] = useState(false);
  const [venmoDetails, setVenmoDetails] = useState(false);
  const [shippingDetails, setShippingDetails] = useState(true);
  const [tradeInventory, setTradeInventory] = useState(true);
  const [inventoryError, setInventoryError] = useState("");
  const [invoiceId, setInvoiceId] = useState(null);
  const [shipping, setShipping] = useState(null);
  const [tax, setTax] = useState(null);
  const [fees, setFees] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [deposit, setDeposit] = useState(null);
  const [paymentmethod, setPaymentMethod] = useState(null);
  const [qtyShrink, setQtyShrink] = useState(true);
  const [descShrink, setDescShrink] = useState(false);
  const [editIdx, setEditIdx] = useState(null);
  const [model, setModelList] = useState(props?.modelList);
  const [serialList, setSerialList] = useState([]);
  const [searchObj, setSearchObj] = useState({});
  const [modelNo, setModel] = useState(null);
  const [serial, setSerial] = useState(null);
  const [image, setImage] = useState(null);
  const [desc, setDesc] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [inventoryid, setInventoryId] = useState(null);
  const [productid, setProductId] = useState(null);
  const [selectedInlineInventoryIds, setSelectedInlineInventoryIds] = useState(
    [],
  );
  const [selectedInventoryModel, setSelectedInventoryModel] = useState("");
  const [selectedInventorySerial, setSelectedInventorySerial] = useState("");
  const [selectedInventoryModelName, setSelectedInventoryModelName] =
    useState("");
  const [selectInventoryModelNumber, setSelectInventoryModelNumber] =
    useState("");
  const [selectedInventoryCategory, setSelectedInventoryCategory] =
    useState("");
  const [noData, setNoData] = useState(false);
  const [noBillData, setNoBillData] = useState(false);
  const [noShipData, setNoShipData] = useState(false);
  const [currentSearch, setCurrentSearch] = useState(null);
  const [isSubmitInvoice, setIsSubmitInvoice] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [shipAnchorEl, setShipAnchorEl] = useState(null);
  const shipOpen = Boolean(shipAnchorEl);
  const [anchorTarget, setAnchorTarget] = useState(null);
  const [billCntctNm, setBillCntctNm] = useState(null);
  const [shipCntctNm, setShipCntctNm] = useState(null);
  const [billCntctSearchTxt, setBillCntctSearchTxt] = useState(null);
  const [shipCntctSearchTxt, setShipCntctSearchTxt] = useState(null);
  const [isBillTextInput, setIsBillTextInput] = useState(false);
  const [isShipTextInput, setIsShipTextInput] = useState(false);
  const [billCntcts, setBillCntctLst] = useState([]);
  const [shipCntcts, setShipCntcts] = useState([]);
  const [countryListData, setCountryListData] = useState([]);
  const [statesListData, setStatesListData] = useState([]);
  const [shippingStatesListData, setShippingStatesListData] = useState([]);
  const [contactListConfirmationModal, SetContactListConfirmationModal] =
    useState(false);
  const [createContactModalOpen, setCreateContactModalOpen] = useState(false);
  const [createContactTarget, setCreateContactTarget] = useState("bill");
  const [finalInvoiceData, setFinalInvoiceData] = useState(null);
  const [shippingCountryCode, setShippingCountryCode] = useState("+1");
  const [billingCountryCode, setBillingCountryCode] = useState("+1");
  const [modalText, setModalText] = useState(
    "This is not in your contacts, Do you want to save it?",
  );
  const [UniqueCountryCode, setUniqueCountryCode] = useState([]);
  const [currency, setCurrency] = useState("USD");
  // const[openpricewarning,setopenpricewarning]=useState(false);
  const [onsubmitdata, setonsubmitdata] = useState("");
  const [purchaseprice, setpurchaseprice] = useState("");
  const [price, setprice] = useState(null);
  const [isPopoverVisiblebill, setIsPopoverVisiblebill] = useState(false);
  const [isPopoverVisibleship, setIsPopoverVisibleship] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputship, setSearchInputship] = useState("");
  const [isPopoverVisiblemodelno, setIsPopoverVisiblemodelno] = useState(false);
  const [isPopoverVisibleserialno, setIsPopoverVisibleserialno] =
    useState(false);
  const [searchInputmodelno, setSearchInputmodelno] = useState("");
  const [searchInputserialno, setSearchInputserialno] = useState("");
  const [isSerialNumberRequired, setISSerialNumberRequired] = useState(false);
  const [paymentdetails, setPaymentDetails] = useState(null);
  const [type, setType] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [invoiceListData, setInvoiceListData] = useState([]);
  const [saletaxOpen, setSaletaxOpen] = useState(false);
  const [billContactId, setBillContactId] = useState(null);
  const [shipContactId, setShipContactId] = useState(null);
  const [errorCode, setErrorCode] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [reason, setReason] = useState(null);
  const [fieldLoaderBill, setFieldLoaderBill] = useState(null);
  const [fieldLoaderShip, setFieldLoaderShip] = useState(null);
  const [contactValidationError, setContactValidationError] = useState("");
  const [shipContactValidationError, setShipContactValidationError] = useState("");
  const [contactTypeBill, setContactTypeBill] = useState([
    "business_client",
    "end_customer",
  ]);
  const [contactTypeShip, setContactTypeShip] = useState([
    "business_client",
    "end_customer",
  ]);
  const [classificationTypeBill, setClassificationTypeBill] = useState([
    "supplier",
    "memo_supplier",
    "partner",
  ]);
  const [classificationTypeShip, setClassificationTypeShip] = useState([
    "supplier",
    "memo_supplier",
    "partner",
  ]);
  const [watchType, setWatchType] = useState("standard_watch");
  const [tradeWatchType, setTradeWatchType] = useState("");
  const [tradeModel, setTradeModel] = useState(null);
  const [tradeModelName, setTradeModelName] = useState(null);
  const [tradeSerialNumber, setTradeSerialNumber] = useState(null);
  const [tradeModelNumber, setTradeModelNumber] = useState(null);
  const [tradeInventoryPrice, setTradeInventoryPrice] = useState(null);

  const [tradeMiscCategory, setTradeMiscCategory] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchTradeObj, setSearchTradeObj] = useState({});
  const [tradeProductId, setTradeProductId] = useState("");
  const [propsModelList, setPropsModelList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentError, setPaymentError] = useState(false);
  const [salestaxSkipReason, setSalestaxSkipReason] = useState(null);
  const [soldDate, setSoldDate] = useState(
    formatDate(new Date(), "MM/DD/YYYY", false),
  );
  const [invoiceSettings, setInvoiceSettings] = useState(null);
  const [classification_type, setClassificationType] = useState("");
  const [clearAddRow, setClearAddRow] = useState(false);
  const [contact_type, setContactType] = useState("");
  const isSalesTaxIncluded = invoiceSettings?.data?.[0]?.is_include_salestax;
  // Using Existing Inventory ONLY
  const [tradeSearchObj, setTradeSearchObj] = useState({});
  const [TradeInventoryId, setTradeInventoryId] = useState(null);
  const [tradeAutoValue, setTradeAutoValue] = useState(null);
  const [depositError, setDepositError] = useState("");
  const [openQBOInvoiceModal, setOpenQBOInvoiceModal] = useState(false);
  const [isInvoiceQboSynced, setIsInvoiceQboSynced] = useState(true);
  const [billSearchType, setBillSearchType] = useState("other_option");
  const [shipSearchType, setShipSearchType] = useState("other_option");
  const [dealerList, setDealerList] = useState([]);
  const [dealerListLoading, setDealerListLoading] = useState(false);
  const [isPopoverVisibleDealer, setIsPopoverVisibleDealer] = useState(false);
  const [dealerAnchor, setDealerAnchor] = useState(null);
  const [dealerAccountId, setDealerAccountId] = useState(null);
  const [dealerUserId, setDealerUserId] = useState(null);
  const [isWalkInContactSelected, setIsWalkInContactSelected] = useState(false);
  const [isShipWalkInContactSelected, setIsShipWalkInContactSelected] = useState(false);
  const [, forceShipLabelUpdate] = useState(0);
  const [, forceBillLabelUpdate] = useState(0);

  const createTradeMiscWatchSerialNumber = () =>
    "Not Available-" + new Date().getTime();

  const isAutoGeneratedTradeSerialNumber = (value) =>
    typeof value === "string" && value.startsWith("Not Available-");

  const updateTradeSerialNumber = (value) => {
    setTradeSerialNumber(value);
    setValue1("tradeSerialNumber", value || "");
  };
  const [initialAmount, setInitialAmount] = useState("");
  const [depositAmountError, setDepositAmountError] = useState("");
  const [walkInValidationError, setWalkInValidationError] = useState("");
  const { data, isConvertToSale = false, invoiceFilter } = location.state || {};
  const billingState = watch1("billingToState");
  const shippingState = watch1("shippingToState");
  const billingZip = watch1("billingToZip");
  const shippingZip = watch1("shippingToZip");
  const [dealerPushConfirmOpen, setDealerPushConfirmOpen] = useState(false);
  const [createdInvoiceId, setCreatedInvoiceId] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleShipClick = (event) => {
    setShipAnchorEl(event.currentTarget);
  };

  const handleShipClose = () => {
    setShipAnchorEl(null);
  };

  const isShippingFieldDisabled = (columnIsDisabled) => {
    if (isSameAddress) return true;
    if (isOnetimeShippingAddress) return false;
    if (shipSearchType === "walk_in") return isShipWalkInContactSelected;
    return !!columnIsDisabled;
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        Object.keys(searchTradeObj).length &&
        searchTradeObj?.searchVal?.length > 2
      ) {
        setSearchLoading(true);
        searchProductsAPI(searchTradeObj, (error, res) => {
          setSearchLoading(false);
          if (error) {
            // console.log(error, res);
          }
          if (res && res.data) {
            setPropsModelList(res.data);
          }
        });
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchTradeObj]);

  useEffect(() => {
    if (paymentmethod !== "Trade" || !tradeInventory) {
      return;
    }

    if (watchType === "misc_watch" && tradeSerialNumber === null) {
      updateTradeSerialNumber(createTradeMiscWatchSerialNumber());
    }

    if (
      watchType !== "misc_watch" &&
      isAutoGeneratedTradeSerialNumber(tradeSerialNumber)
    ) {
      updateTradeSerialNumber(null);
    }
  }, [watchType, paymentmethod, tradeInventory, tradeSerialNumber]);

  useEffect(() => {
    if (data && Object.keys(data) && Object.keys(data)?.length > 0) {
      const { id } = data || {};
      getMemoDetails(id);
    }
  }, [data]);

  useEffect(() => {
    const isBillWalkInFlow = billSearchType === "walk_in";
    if (
      invoiceSettings &&
      (billContactId || isBillWalkInFlow) &&
      (classification_type || contact_type || isBillWalkInFlow)
    ) {
      calculateTax();
    }
  }, [invoiceSettings, classification_type, contact_type, billContactId, rows, billSearchType]);

  //   useEffect(() => {
  //  if (tradeInventory) return;
  //     if (type) {
  //        setTradeWatchType(type);
  //     }

  // if (selectedInventoryModel) {
  //   setTradeModel(selectedInventoryModel);
  // }

  //  if (selectedInventorySerial) {
  //   console.log('im setting here 1111111111111111111111111')
  //   setTradeSerialNumber(selectedInventorySerial);
  // }
  // if (selectedInventoryModelName) {
  //   setTradeModelName(selectedInventoryModelName);
  // }
  // if (selectInventoryModelNumber) {
  //   setTradeModelNumber (selectInventoryModelNumber)
  // }
  // if (selectedInventoryCategory) {
  //   setTradeMiscCategory (selectedInventoryCategory)
  // }

  // }, [
  //   tradeInventory,
  //   inventoryid,
  //   type,
  //   selectedInventoryModel,
  //   selectedInventorySerial,
  //   selectedInventoryModelName,
  //   selectInventoryModelNumber,
  //   selectedInventoryCategory
  // ]);
  useEffect(() => {
    getInvoiceSetting((err, res) => {
      if (!err) {
        setInvoiceSettings(res);
      } else {
        console.error("Failed to fetch invoice settings", err);
      }
    });
  }, []);

  //   useEffect(() => {
  //   if (paymentmethod === "Trade") {
  //     setTradeInventory(true);
  //   } else {
  //     setTradeInventory(false);
  //   }
  // }, [paymentmethod]);

  useEffect(() => {
    if (
      invoiceSettings &&
      billContactId &&
      (classification_type || contact_type)
    ) {
      calculateTax();
    }
  }, [invoiceSettings, classification_type, contact_type, billContactId, rows]);
  useEffect(() => {
    if (
      invoiceSettings &&
      (billContactId || billSearchType === "walk_in") &&
      classification_type !== "business_client" &&
      contact_type !== "business_client"
    ) {
      calculateTax();
    }
  }, [discount]);

  useEffect(() => {
    if (props?.location?.state?.inventoryDetails) {
      setInventoryId(props?.location?.state?.inventoryDetails?.inventoryid);
      setRows([
        {
          modelNumber: props?.location?.state?.inventoryDetails?.model,
          serialNumber: props?.location?.state?.inventoryDetails?.serialno,
          productName: props?.location?.state?.inventoryDetails?.desc,
          image: props?.location?.state?.inventoryDetails?.image,
          inventoryId: props?.location?.state?.inventoryDetails?.inventoryid,
          productId: props?.location?.state?.inventoryDetails?.productid,
          quantity: props?.location?.state?.inventoryDetails?.quantity
            ? props?.location?.state?.inventoryDetails?.quantity
            : 1,
          amount: "",
          sold_price: "",
          currency: currency,
          type: props?.location?.state?.inventoryDetails?.type,
        },
      ]);
      const currentRow = {
        amount: "",
        sold_price: "",
        image: props?.location?.state?.inventoryDetails?.image,
        modelNumber: props?.location?.state?.inventoryDetails?.model,
        productName: props?.location?.state?.inventoryDetails?.desc,
        quantity: props?.location?.state?.inventoryDetails?.quantity
          ? props?.location?.state?.inventoryDetails?.quantity
          : 1,
        serialNumber: props?.location?.state?.inventoryDetails?.serialno,
        inventoryId: props?.location?.state?.inventoryDetails?.inventoryid,
        productId: props?.location?.state?.inventoryDetails?.productid,
        from: "inventory",
        currency: currency,
        type: props?.location?.state?.inventoryDetails?.type,
        inventoryid: props?.location?.state?.inventoryDetails?.inventoryid,
      };
      setAnchorEl(null);
      setCurrentItem(currentRow);
      reset(currentRow);
      setEditIdx(0);
      setModel(props?.location?.state?.inventoryDetails?.model);
      setSerial(props?.location?.state?.inventoryDetails?.serialno);
      setProductId(props?.location?.state?.inventoryDetails?.productid);
      setprice(props?.location?.state?.inventoryDetails?.purchaseprice);
      setInventoryId(props?.location?.state?.inventoryDetails?.inventoryid);
      setQuantity(
        props?.location?.state?.inventoryDetails?.quantity
          ? props?.location?.state?.inventoryDetails?.quantity
          : 1,
      );
      setType(
        props?.location?.state?.inventoryDetails?.type
          ? props?.location?.state?.inventoryDetails?.type
          : null,
      );
      setDesc(props?.location?.state?.inventoryDetails?.desc || "");
      if (props?.location?.state?.inventoryDetails?.desc) {
        setDescShrink(true);
      }
      setModalOpen(!openModal);
      setDisabled(true);
    } else {
      setInventoryId(null);
    }
    getcountryList();
  }, [props?.location?.state?.inventoryDetails]);

  useEffect(() => {
    const updatedValues = getValues1();
  }, [billingState, shippingState, billingZip, shippingZip]);

  useEffect(() => {
    try {
      const bCountry = getValues1()["billingToCountry"];
      if (bCountry) {
        const canonical = canonicalOptionName(
          bCountry,
          countryListData,
          bCountry,
        );
        if (canonical !== bCountry) setValue1("billingToCountry", canonical);
      }

      const sCountry = getValues1()["shippingToCountry"];
      if (sCountry) {
        const canonical = canonicalOptionName(
          sCountry,
          countryListData,
          sCountry,
        );
        if (canonical !== sCountry) setValue1("shippingToCountry", canonical);
      }

      const bState = getValues1()["billingToState"];
      if (bState) {
        const canonical = canonicalOptionName(bState, statesListData, bState);
        if (canonical !== bState) setValue1("billingToState", canonical);
      }

      const sState = getValues1()["shippingToState"];
      if (sState) {
        const canonical = canonicalOptionName(
          sState,
          shippingStatesListData,
          sState,
        );
        if (canonical !== sState) setValue1("shippingToState", canonical);
      }
    } catch (e) { }
  }, [countryListData, statesListData, shippingStatesListData]);

  useEffect(() => {
    // console.log(invoiceId, openQBOInvoiceModal, 'invoiceIdinvoiceIdinvoiceId')
    if (invoiceId !== null && !openQBOInvoiceModal) {
      viewInvoice();
    }
  }, [invoiceId, props.history]);

  useEffect(() => {
    setFieldLoaderBill(false);
    setFieldLoaderShip(false);

    const list = props.billShipCntctLst || [];
    if (billCntctSearchTxt) {
      if (list.length > 0) {
        const filteredData = destructureData(list);

        setdataset(filteredData);
        setBillCntctLst(list);
        setIsPopoverVisiblebill(true);
        setNoBillData(false);
      } else {
        setdataset([]);
        setBillCntctLst([]);
        setIsPopoverVisiblebill(false);
        setNoBillData(false);
      }
    }
    if (shipCntctSearchTxt && !isOnetimeShippingAddress) {
      if (list.length > 0) {
        const filteredData = destructureData(list);

        setshippingdataset(filteredData);
        setShipCntcts(list);
        setIsPopoverVisibleship(true);
        setNoShipData(false);
      } else {
        setshippingdataset([]);
        setShipCntcts([]);
        setIsPopoverVisibleship(false);
        setNoShipData(false);
      }
    }
  }, [props.billShipCntctLst]);

  useEffect(() => {
    setDealerListLoading(false);
    if (billSearchType !== "dealer_name") return;
    const raw = props.dealerBusinessList;
    let results = [];
    if (Array.isArray(raw)) {
      results = raw;
    } else if (raw && typeof raw === "object" && Object.keys(raw).length > 0) {
      results = [raw];
    }

    const loginBusinessName = JSON.parse(
      sessionStorage.getItem("userDetails")
    )?.accountName?.trim().toLowerCase();

    const filteredResults = results.filter(
      (item) =>
        item.businessname?.trim().toLowerCase() !== loginBusinessName
    );

    setDealerList(filteredResults);
    setIsPopoverVisibleDealer(filteredResults.length > 0);
  }, [props.dealerBusinessList]);

  useEffect(() => {
    if (props.modelList && props.modelList?.length > 0) {
      if (modelNo) {
        // setInventoryId(props.inventoryid)
        setModelList(props.modelList);
        setIsPopoverVisiblemodelno(true);
        setNoData(false);
      }
      if (serial) {
        setSerialList(props.modelList);
        setIsPopoverVisibleserialno(true);
        setNoData(false);
      }
    } else {
      if (searchObj?.searchVal?.length > 2) {
        setNoData(true);
      }
    }
  }, [props.modelList, modelNo, serial]);

  // useEffect(()=>{
  //     const timer = setTimeout(() => {
  //         if (Object.keys(searchObj).length && searchObj?.searchVal?.length > 2) {
  //             props.getModelSerialList(searchObj,userId);
  //         }
  //     }, 500);
  //     return () => clearTimeout(timer);
  // },[searchObj]);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (Object.keys(searchObj).length && searchObj?.searchVal?.length > 2) {
        props.getNewModelSerialList(searchObj, accountId);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [searchObj]);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    if (shipinputRef.current) {
      shipinputRef.current.focus();
    }
    if (modelinputRef.current) {
      modelinputRef.current.focus();
    }
    if (serialinputRef.current) {
      serialinputRef.current.focus();
    }
    getInvoiceList();
  }, []);

  useEffect(() => {
    fetchBillContacts(billCntctSearchTxt);
  }, [billCntctSearchTxt]);

  useEffect(() => {
    fetchShipContacts(shipCntctSearchTxt);
  }, [shipCntctSearchTxt]);
  const billFetchStateRef = useRef({});
  billFetchStateRef.current = {
    isBillTextInput,
    contactTypeBill,
    billSearchType,
    accountId,
    getInvoiceNewContactList: props.getInvoiceNewContactList,
  };

  const shipFetchStateRef = useRef({});
  shipFetchStateRef.current = {
    isShipTextInput,
    contactTypeShip,
    shipSearchType,
    isOnetimeShippingAddress,
    accountId,
    getInvoiceNewContactList: props.getInvoiceNewContactList,
  };

  const fetchBillContacts = useCallback(
    _.debounce((searchText) => {
      const {
        isBillTextInput,
        contactTypeBill,
        billSearchType,
        accountId,
        getInvoiceNewContactList,
      } = billFetchStateRef.current;
      if (billSearchType === "dealer_name") return;
      // if (billSearchType === "dealer_name" || billSearchType === "walk_in") return;
      if (!isBillTextInput && searchText && searchText.length > 2) {
        setFieldLoaderBill(true);
        let payload = {
          key: searchText,
          // key: searchText?.replace(/\s/g, ""),
          // contacttype: contactTypeBill,
          contacttype: billSearchType === "walk_in" ? ["walk_in"] : contactTypeBill,
          // type: billSearchType === "walk_in" ? "walk_in" : null,
          type: null,
          accountids: accountIds,
        };
        props
          .getInvoiceNewContactList(payload)
          .then(() => setFieldLoaderBill(false))
          .catch(() => setFieldLoaderBill(false));
      } else {
        setFieldLoaderBill(false);
      }
    }, 500),
    [],
  );
  const triggerDealerSearch = useCallback(
    _.debounce((searchText) => {
      if (!searchText || searchText.length < 3) {
        setDealerList([]);
        setIsPopoverVisibleDealer(false);
        setDealerListLoading(false);
        return;
      }
      setDealerListLoading(true);
      props.dataTransferBusinessList(searchText);
    }, 500),
    [],
  );

  const fetchShipContacts = useCallback(
    _.debounce((searchText) => {
      const {
        isShipTextInput,
        contactTypeShip,
        shipSearchType,
        isOnetimeShippingAddress,
        accountId,
        getInvoiceNewContactList,
      } = shipFetchStateRef.current;

      if (isOnetimeShippingAddress) {
        setFieldLoaderShip(false);
        setShipCntcts([]);
        setIsPopoverVisibleship(false);
        return;
      }

      if (!isShipTextInput && searchText && searchText.length > 2) {
        setFieldLoaderShip(true);
        let payload = {
          key: searchText,
          // key: searchText?.replace(/\s/g, ""),
          contacttype: shipSearchType === "walk_in" ? ["walk_in"] : contactTypeShip,
          type: null,
          // contacttype: contactTypeShip,
          // type: shipSearchType === "walk_in" ? "walk_in" : null,
          accountids: accountIds,
        };
        props
          .getInvoiceNewContactList(payload)
          .then(() => setFieldLoaderShip(false))
          .catch(() => setFieldLoaderShip(false));
      } else {
        setFieldLoaderShip(false);
      }
    }, 500),
    [],
  );
  const { id } = data || {};

  // const addressForm = watch1();

  const canonicalOptionName = (raw, options, fallback = null) => {
    if (!raw && raw !== "") return fallback;
    const trimmed = raw.toString().trim();
    if (!options || !options.length) return trimmed || fallback;
    const match = options.find((opt) => {
      if (!opt) return false;
      const name = (opt.name || "").toString().trim();
      return name.toLowerCase() === trimmed.toLowerCase();
    });
    return match ? match.name || trimmed : trimmed || fallback;
  };

  const userId = props?.currentUser?.userId ? props?.currentUser?.userId : null;
  // const accountId = props?.currentUser?.accountId ? props?.currentUser?.accountId : null;

  const userDetails = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;

  const accountIds =
    userDetails?.accountdetails?.map((acc) => acc.accountid) || [];

  const applyTaxFieldValue = (value) => {
    const parsed = parseFloat(value);
    if (value === null || value === undefined || value === "" || isNaN(parsed) || parsed === 0) {
      setTax(null);
      setValue1("tax", "");
      return;
    }

    const formattedTax = Number(parsed).toFixed(2);
    setTax(formattedTax);
    setValue1("tax", formattedTax);
  };

  const calculateTax = () => {
    const taxSetting = invoiceSettings?.data?.[0];

    if (!taxSetting || !invoiceSettings?.data?.length) return;
    const isBusinessClient =
      classification_type === "business_client" ||
      contact_type === "business_client";
    const backendTax = getValues1("tax") || taxSetting?.sales_tax || "0.00";

    if (isBusinessClient) {
      if (isConvertToSale && Number(backendTax) > 0) {
        applyTaxFieldValue(backendTax);
      } else {
        applyTaxFieldValue(null);
      }
      return;
    }

    if (isConvertToSale && taxSetting?.is_include_salestax === false) {
      applyTaxFieldValue(backendTax);
      return;
    }

    const discount = parseFloat(getValues1("discount") || 0);
    const selectedRows = isConvertToSale ? rows.filter((r) => r.checked) : rows;
    const totalAmount = selectedRows.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0,
    );

    const taxRate = parseFloat(taxSetting?.tax_percentage || 0);
    let taxableAmount = totalAmount - discount;
    if (taxableAmount <= 0 || taxRate <= 0) {
      applyTaxFieldValue(null);
      return;
    }

    const rawTax = (taxableAmount * taxRate) / 100;
    const truncatedTax = Math.floor(rawTax * 100) / 100;
    const formattedTax = isNaN(truncatedTax)
      ? backendTax
      : truncatedTax.toFixed(2);

    applyTaxFieldValue(formattedTax);
  };
  const normalizeContactTypeForDropdown = (value) => {
    const normalizedValue = `${value || ""}`.toString().trim().toLowerCase();

    if (["retail", "business", "business_client"].includes(normalizedValue)) {
      return "other_option";
    }

    if (["walkin", "walk_in", "walk-in", "temporary", "temporary_customer"].includes(normalizedValue)) {
      return "walk_in";
    }

    if (["dealer", "dealer_name", "watchops_dealer", "watchops dealer"].includes(normalizedValue)) {
      return "dealer_name";
    }

    return "other_option";
  };

  const isTruthyFlag = (value) =>
    value === true || value === 1 || value === "1" || value === "true";

  const getMemoDetails = (memoId) => {
    setIsLoading(true);
    props.getMemoList(
      memoId,
      (success) => {
        if (success.status === 1) {
          memoDetailsMapping(success?.data?.[0]);
          setIsLoading(false);
        } else {
          showErrorToast(success.message);
          setIsLoading(false);
        }
      },
      (error) => {
        setDisabled(false);
        showErrorToast(error);
        setIsLoading(false);
      },
    );
  };

  const memoDetailsMapping = (memoData) => {
    const {
      memoproductdetails,
      shippingprice,
      discount,
      tax,
      fees,
      deposit,
      memoterm,
      shippingdate,
      soldDate,
      shippingmethod,
      is_shippingdetails,
      trackingnumber,
      wiredetails,
      zelledetails,
      venmodetails,
      notes,
      billingcontactname,
      acceptable_payment,
      bilingcontactid,
      billingbusinessname,
      billingphone,
      billingcountrycode,
      billingemail,
      billingaddress1,
      billingaddress2,
      billingcity,
      billingstates,
      billingcountry,
      billingzipcode,
      issameaddress,
      shippingcontactname,
      shippingbusinessname,
      shippingcontactid,
      shippingphone,
      shippingcountrycode,
      shippingemail,
      shippingaddress1,
      shippingaddress2,
      shippingcity,
      shippingstates,
      shippingcountry,
      shippingzipcode,
      contact_type,
    } = memoData || {};
    const dealerMapping = getDealerContactMapping(memoData);
    const billingContactType = normalizeContactTypeForDropdown(memoData?.billing_contact_type);
    const shippingContactType = normalizeContactTypeForDropdown(memoData?.shipping_contact_type);
    const normalizeMemoPhone = (value) => {
      const phone = value ? value.toString().trim() : "";
      if (!phone || ["null", "<null>", "undefined"].includes(phone.toLowerCase())) {
        return null;
      }
      return phone.replace(/\W+/g, "") || null;
    };
    const normalizedBillingPhone = normalizeMemoPhone(billingphone);
    const normalizedShippingPhone = normalizeMemoPhone(shippingphone);
    const isMemoSameAddress = issameaddress || false;
    const isMemoOneTimeShipping =
      !isMemoSameAddress &&
      (isTruthyFlag(memoData?.isOnetimeShippingAddress) ||
        isTruthyFlag(memoData?.is_onetime_shipping_address) ||
        isTruthyFlag(memoData?.isonetimeshippingaddress) ||
        (!shippingcontactid &&
          Boolean(shippingcontactname || shippingaddress1)));
    setIsOnetimeShippingAddress(isMemoOneTimeShipping);
    const { memo } = memoproductdetails || {};
    const updatedRows = memo
      ?.filter((item) => item.status?.toLowerCase() === "out on memo")
      ?.map((item) => {
        const {
          amount,
          currency,
          quantity,
          serialno,
          productid,
          description,
          inventoryid,
          modelnumber,
          technical_details,
        } = item;
        const { model_number, product_title } = technical_details || {};
        return {
          modelNumber: modelnumber || model_number || "",
          serialNumber: serialno || "",
          productName: description || product_title || "",
          image: getInventoryDisplayImage(item),
          inventoryId: inventoryid || null,
          productId: productid || null,
          quantity: quantity || 1,
          amount: amount || null,
          sold_price: amount || null,
          currency: currency || null,
          checked: true,
        };
      });
    setRows(updatedRows || []);
    setValue1("shippingPrice", shippingprice || null);
    setShipContactId(
      isMemoOneTimeShipping
        ? null
        : isMemoSameAddress ? bilingcontactid : shippingcontactid,);
    setBillContactId(bilingcontactid);
    setValue1("discount", discount || null);
    setValue1("tax", tax || null);
    setValue1("fees", fees || null);
    setValue1("deposit", deposit || null);
    setValue1(
      "terms",
      memoterm && memoterm !== "Immediate" ? `Net ${memoterm}` : "Immediate",
    );
    setShippingDate(
      shippingdate ? formatDate(shippingdate, "MM/DD/YYYY") : null,
    );
    setSoldDate(
      soldDate
        ? formatDate(soldDate, "MM/DD/YYYY", false)
        : formatDate(new Date(), "MM/DD/YYYY"),
      false,
    );
    setValue1("shippingMethod", shippingmethod || null);
    setValue1("trackingNumber", trackingnumber || null);
    setValue1("notes", notes || null);
    setNotes(notes);
    setWireDetails(
      wiredetails !== undefined && wiredetails !== null ? wiredetails : true,
    );
    setZelleDetails(
      zelledetails !== undefined && zelledetails !== null
        ? zelledetails
        : false,
    );
    setVenmoDetails(
      venmodetails !== undefined && venmodetails !== null
        ? venmodetails
        : false,
    );
    setShippingDetails(
      is_shippingdetails !== undefined && is_shippingdetails !== null
        ? is_shippingdetails
        : false,
    );
    const useDealerValues =
      dealerMapping.isDealerFlow ||
      billingContactType === "dealer_name" ||
      shippingContactType === "dealer_name";
    const useDealerValuesForBilling = billingContactType === "dealer_name";
    const useDealerValuesForShipping = shippingContactType === "dealer_name";
    const billSearchTypeValue = billingContactType;
    const shipSearchTypeValue = shippingContactType;
    const effectiveBillingCountry = useDealerValuesForBilling
      ? dealerMapping.billingCountry
      : billingcountry;
    const effectiveShippingCountry = useDealerValuesForShipping
      ? dealerMapping.shippingCountry
      : isMemoSameAddress
        ? billingcountry
        : shippingcountry;

    const fetchStatesForCountry = (countryName, setter) => {
      if (!countryName) return;
      const trimmedName = countryName.toString().trim().toLowerCase();
      const filterCountry = countryListData.find(
        (country) => country.name?.toLowerCase() === trimmedName,
      );
      if (filterCountry && filterCountry.id) {
        getUserdetailsforsubscrption
          .getAllStateList(filterCountry.id)
          .then((res) => {
            setter(res?.data?.data || []);
          })
          .catch(() => {
            setter([]);
          });
      }
    };

    fetchStatesForCountry(effectiveBillingCountry, setStatesListData);
    if (!isMemoSameAddress) {
      fetchStatesForCountry(effectiveShippingCountry, setShippingStatesListData);
    }
    // const billingName = useDealerValues ? dealerMapping.billingName : billingcontactname || null;
    // const shippingName = useDealerValuesForShipping ? dealerMapping.shippingName : shippingcontactname || null;
    const billingName = useDealerValues ? dealerMapping.billingName : billingcontactname || null;
    const shippingName = useDealerValuesForShipping
      ? dealerMapping.shippingName
      : isMemoSameAddress
        ? billingName
        : shippingcontactname || null;
    setValue1("billingToName", billingName);
    setBillCntctNm(billingName);
    setPaymentContactBased(
      acceptable_payment && acceptable_payment.length > 0
        ? acceptable_payment
        : [],
    );
    setValue1("billingToBusinessName", useDealerValuesForBilling ? dealerMapping.billingBusinessName : billingbusinessname);
    setValue1("billingToPhoneNo", useDealerValuesForBilling ? dealerMapping.billingPhone : normalizedBillingPhone);
    setBillingCountryCode(
      useDealerValuesForBilling
        ? dealerMapping.billingCountryCode || ""
        : normalizedBillingPhone ? billingcountrycode || "" : "",
    );
    setValue1("billingToEmail", useDealerValuesForBilling ? dealerMapping.billingEmail : billingemail || null);
    setValue1("billingToAddressLine1", useDealerValuesForBilling ? dealerMapping.billingAddress1 : billingaddress1 || null);
    setValue1("billingToAddressLine2", useDealerValuesForBilling ? dealerMapping.billingAddress2 : billingaddress2 || null);
    setValue1("billingToCity", useDealerValuesForBilling ? dealerMapping.billingCity : billingcity || null);
    setValue1(
      "billingToState",
      useDealerValuesForBilling
        ? dealerMapping.billingState || null
        : canonicalOptionName(billingstates, statesListData, null),
    );
    setValue1(
      "billingToCountry",
      useDealerValuesForBilling
        ? dealerMapping.billingCountry || "United States"
        : canonicalOptionName(billingcountry, countryListData, "United States"),
    );
    setValue1("billingToZip", useDealerValuesForBilling ? dealerMapping.billingZip : billingzipcode || null);
    setShipCntctNm(shippingName);
    setValue1("shippingToName", shippingName);
    setValue1(
      "shippingToBusinessName",
      useDealerValuesForShipping
        ? dealerMapping.shippingBusinessName
        : isMemoSameAddress
          ? billingbusinessname
          : shippingbusinessname || null,
    );
    setValue1("shippingToPhoneNo", useDealerValuesForShipping ? dealerMapping.shippingPhone : isMemoSameAddress ? normalizedBillingPhone : normalizedShippingPhone);
    setShippingCountryCode(
      useDealerValuesForShipping
        ? dealerMapping.shippingCountryCode || ""
        : isMemoSameAddress
          ? normalizedBillingPhone
            ? billingcountrycode || ""
            : ""
          : normalizedShippingPhone
            ? shippingcountrycode || ""
            : "",
    );
    setValue1(
      "shippingToEmail",
      useDealerValuesForShipping
        ? dealerMapping.shippingEmail
        : isMemoSameAddress
          ? billingemail
          : shippingemail || null,
    );
    setValue1(
      "shippingToAddressLine1",
      useDealerValuesForShipping
        ? dealerMapping.shippingAddress1
        : isMemoSameAddress
          ? billingaddress1
          : shippingaddress1 || null,
    );
    setValue1(
      "shippingToAddressLine2",
      useDealerValuesForShipping
        ? dealerMapping.shippingAddress2
        : isMemoSameAddress
          ? billingaddress2
          : shippingaddress2 || null,
    );
    setValue1(
      "shippingToCity",
      useDealerValuesForShipping
        ? dealerMapping.shippingCity
        : isMemoSameAddress
          ? billingcity
          : shippingcity || null,
    );
    setValue1(
      "shippingToState",
      useDealerValuesForShipping
        ? dealerMapping.shippingState || null
        : isMemoSameAddress
          ? canonicalOptionName(billingstates, statesListData, null)
          : canonicalOptionName(shippingstates, shippingStatesListData, null),
    );
    setValue1(
      "shippingToCountry",
      useDealerValuesForShipping
        ? dealerMapping.shippingCountry || "United States"
        : isMemoSameAddress
          ? canonicalOptionName(billingcountry, countryListData, "United States")
          : canonicalOptionName(shippingcountry, countryListData, "United States"),
    );
    setValue1(
      "shippingToZip",
      useDealerValuesForShipping
        ? dealerMapping.shippingZip
        : isMemoSameAddress
          ? billingzipcode
          : shippingzipcode || null,
    );
    setBillSearchType(billSearchTypeValue);
    setShipSearchType(isMemoOneTimeShipping ? "other_option" : shipSearchTypeValue);
    setValue1("billingSearchType", billSearchTypeValue);
    setValue1("shippingSearchType", isMemoOneTimeShipping ? "other_option" : shipSearchTypeValue);
    if (useDealerValuesForBilling) {
      setDealerAccountId(dealerMapping.dealerAccountId);
      setDealerUserId(dealerMapping.dealerUserId);
    }
    setSameAddress(isMemoSameAddress);
    setDisabled(true);
    setClassificationType(contact_type);
  };

  // const isStateChanged = watch1("billingToState") || watch1("shippingToState")
  //   || watch1("billingToZip") || watch1("shippingToZip");

  const getcountryList = () => {
    getUserdetailsforsubscrption.getAllCountryList().then((res) => {
      setCountryListData(res?.data?.data);
      let countries = res?.data?.data;
      let countryCode = [];
      countries.filter(({ phonecode }) => countryCode.push(phonecode));
      const UniqueCountryCode = [...new Set(countryCode)];
      setUniqueCountryCode(UniqueCountryCode.sort());
    });
    // us States List 231
    getUserdetailsforsubscrption.getAllStateList(231).then((res) => {
      setStatesListData(res.data.data);
      setShippingStatesListData(res.data.data);
    });
  };

  // const isTwoAddressSame = (input, dbData, type) => {
  //   let isChanged = false;
  //   if (type === "shipping") {
  //     if (
  //       (dbData.businessname && dbData.businessname.toLowerCase()) !==
  //       (input.shippingToBusinessName &&
  //         input.shippingToBusinessName.toLowerCase()) ||
  //       (dbData.address1 && dbData.address1.toLowerCase()) !==
  //       (input.shippingToAddressLine1 &&
  //         input.shippingToAddressLine1.toLowerCase()) ||
  //       (dbData.address2 && dbData.address2.toLowerCase()) !==
  //       (input.shippingToAddressLine2
  //         ? input.shippingToAddressLine2 &&
  //         input.shippingToAddressLine2.toLowerCase()
  //         : "") ||
  //       (dbData.city && dbData.city.toLowerCase()) !==
  //       (input.shippingToCity && input.shippingToCity.toLowerCase()) ||
  //       (dbData.states && dbData.states.toLowerCase()) !==
  //       (input.shippingToState && input.shippingToState.toLowerCase()) ||
  //       (dbData.country && dbData.country.toLowerCase()) !==
  //       (input.shippingToCountry && input.shippingToCountry.toLowerCase()) ||
  //       (dbData.zipcode && dbData.zipcode.toLowerCase()) !==
  //       (input.shippingToZip && input.shippingToZip.toLowerCase()) ||
  //       (dbData.countrycode && dbData.countrycode.toLowerCase()) !==
  //       (shippingCountryCode && shippingCountryCode.toLowerCase())
  //     ) {
  //       isChanged = true;
  //     }
  //     return isChanged;
  //   } else {
  //     if (
  //       (dbData.businessname && dbData.businessname.toLowerCase()) !==
  //       (input.billingToBusinessName &&
  //         input.billingToBusinessName.toLowerCase()) ||
  //       (dbData.address1 && dbData.address1.toLowerCase()) !==
  //       (input.billingToAddressLine1 &&
  //         input.billingToAddressLine1.toLowerCase()) ||
  //       (dbData.address2 && dbData.address2.toLowerCase()) !==
  //       (input.billingToAddressLine2 &&
  //         input.billingToAddressLine2.toLowerCase()) ||
  //       (dbData.city && dbData.city.toLowerCase()) !==
  //       (input.billingToCity && input.billingToCity.toLowerCase()) ||
  //       (dbData.states && dbData.states.toLowerCase()) !==
  //       (input.billingToState && input.billingToState.toLowerCase()) ||
  //       (dbData.country && dbData.country.toLowerCase()) !==
  //       (input.billingToCountry && input.billingToCountry.toLowerCase()) ||
  //       (dbData.zipcode && dbData.zipcode.toLowerCase()) !==
  //       (input.billingToZip && input.billingToZip.toLowerCase()) ||
  //       (dbData.countrycode && dbData.countrycode.toLowerCase()) !==
  //       (billingCountryCode && billingCountryCode.toLowerCase())
  //     ) {
  //       isChanged = true;
  //     }
  //     return isChanged;
  //   }
  // };

  const onCreateInvoiceSubmit = (
    formData,
    salesTaxId = true,
    invoiceAmount = true,
  ) => {
    const getTotalInvoiceAmount = () => {
      const inventoryTotal = rows.reduce(
        (sum, row) => sum + (parseFloat(row.amount) || 0),
        0,
      );

      const shipping = parseFloat(formData?.shippingPrice || 0);
      const tax = parseFloat(formData?.tax || 0);
      const fees = parseFloat(formData?.fees || 0);
      const discount = parseFloat(formData?.discount || 0);

      return inventoryTotal + shipping + tax + fees - discount;
    };
    const inventoryTotal = rows.reduce(
      (sum, row) => sum + (parseFloat(row.amount) || 0),
      0,
    );

    const shipping = parseFloat(formData?.shippingPrice || 0);
    const tax = parseFloat(formData?.tax || 0);
    const fees = parseFloat(formData?.fees || 0);
    const discount = parseFloat(formData?.discount || 0);

    const totalInvoiceAmount =
      inventoryTotal + shipping + tax + fees - discount;

    const deposit = parseFloat(formData?.deposit || 0);
    const oldDeposit = parseFloat(initialAmount || 0);

    if (paymentmethod !== "Trade" && deposit > totalInvoiceAmount) {
      setDepositError(
        "The total invoice amount (inventory, shipping, tax, and fees minus discount/deposit) must be greater than zero.",
      );
      setIsSubmitInvoice(false);
      return false;
    }
    if (paymentmethod === "Trade" && (!deposit || deposit <= 0)) {
      setDepositAmountError("Please enter the deposit amount to proceed!");
      setIsSubmitInvoice(false);
      return false;
    }
    setDepositError("");
    const isBillWalkIn = billSearchType === "walk_in";
    const isBillDealer = billSearchType === "dealer_name";
    const isShipWalkIn = shipSearchType === "walk_in";
    const isWalkInSameContact =
      isBillWalkIn &&
      isShipWalkIn &&
      !isWalkInContactSelected &&
      !isShipWalkInContactSelected &&
      (formData?.billingToName || "").trim().toLowerCase() ===
      (formData?.shippingToName || "").trim().toLowerCase() &&
      (formData?.billingToBusinessName || "").trim().toLowerCase() ===
      (formData?.shippingToBusinessName || "").trim().toLowerCase() &&
      (formData?.billingToEmail || "").trim().toLowerCase() ===
      (formData?.shippingToEmail || "").trim().toLowerCase() &&
      (billingCountryCode || "").trim() ===
      (shippingCountryCode || "").trim() &&
      (formData?.billingToPhoneNo || "").trim() ===
      (formData?.shippingToPhoneNo || "").trim();
    const isShipSameWalkInAsBill =
      isBillWalkIn &&
      isShipWalkIn &&
      !isWalkInContactSelected &&
      !isShipWalkInContactSelected &&
      formData?.shippingToPhoneNo === formData?.billingToPhoneNo &&
      formData?.shippingToEmail === formData?.billingToEmail;
    const normalize = (v) => (v || "").toString().trim().toLowerCase();
    const isBillNewWalkIn =
      billSearchType === "walk_in" && !isWalkInContactSelected;

    const isShipNewWalkIn =
      shipSearchType === "walk_in" && !isShipWalkInContactSelected;

    if (isBillNewWalkIn && isShipNewWalkIn) {
      const billEmailNorm = normalize(formData.billingToEmail);
      const shipEmailNorm = normalize(formData.shippingToEmail);
      const billPhoneNorm =
        normalize(billingCountryCode) + normalize(formData.billingToPhoneNo);
      const shipPhoneNorm =
        normalize(shippingCountryCode) + normalize(formData.shippingToPhoneNo);

      const sameEmail =
        billEmailNorm.length > 0 && billEmailNorm === shipEmailNorm;

      const samePhone =
        normalize(formData.billingToPhoneNo).length > 0 &&
        billPhoneNorm === shipPhoneNorm;

      const sameContactName =
        normalize(formData.billingToName) ===
        normalize(formData.shippingToName);

      const sameBusinessName =
        normalize(formData.billingToBusinessName) ===
        normalize(formData.shippingToBusinessName);

      if (
        (sameEmail || samePhone) &&
        (!sameContactName || !sameBusinessName)
      ) {
        setWalkInValidationError(
          "The same email address and phone number cannot be used with a different Customer Name or Business Name across Bill To and Ship To. Please use the same Customer Name and Business Name, or provide a different email address or phone number."
        );
        setIsSubmitInvoice(false);
        return false;
      }
      setWalkInValidationError("");
    }
    if (
      !formData?.billingToName ||
      (!isBillDealer && !formData?.shippingToName) ||
      (!billContactId && !isBillWalkIn && !isBillDealer) ||
      // (isBillDealer && (!dealerAccountId || !dealerUserId)) ||
      (!shipContactId &&
        !isBillDealer &&
        !(isSameAddress ? isBillWalkIn : isShipWalkIn || isOnetimeShippingAddress))
    ) {
      if (!formData?.billingToName) {
        showErrorToast("Please enter or select a billing contact name.");
      } else if (!isBillDealer && !formData?.shippingToName) {
        showErrorToast(isOnetimeShippingAddress
            ? "Please enter the contact name for one-time shipping."
            : "Please enter or select a shipping contact name.",);
      } else if (!billContactId && !isBillWalkIn && !isBillDealer) {
        showErrorToast(
          "Please select a billing contact from the list (or create and select a contact) before creating the invoice.",
        );
      } else if (
        !shipContactId &&
        !isBillDealer &&
        !(isSameAddress ? isBillWalkIn : isShipWalkIn || isOnetimeShippingAddress)
      ) {
        showErrorToast(
          isSameAddress
            ? "Billing contact is missing. Please select or create a billing contact."
            : "Please select a shipping contact before creating the invoice.",
        );
      }
      setIsSubmitInvoice(false);
      return false;
    }
    if (
      isOnetimeShippingAddress &&
      !isSameAddress &&
      !isBillDealer
    ) {
      const shipName = (formData?.shippingToName || "").toString().trim();
      const shipAddress1 = (formData?.shippingToAddressLine1 || "")
        .toString()
        .trim();
      const shipAddress2 = (formData?.shippingToAddressLine2 || "")
        .toString()
        .trim();
      const shipCity = (formData?.shippingToCity || "").toString().trim();
      const shipState = (formData?.shippingToState || "").toString().trim();
      const shipCountry = (formData?.shippingToCountry || "").toString().trim();

      if (!shipName) {
        showErrorToast("Please enter the contact name for one-time shipping.");
        setIsSubmitInvoice(false);
        return false;
      }
      if (!shipAddress1 && !shipAddress2) {
        showErrorToast(
          "Please enter Address Line 1 or Address Line 2 for one-time shipping.",
        );
        setIsSubmitInvoice(false);
        return false;
      }
      if (!shipCity) {
        showErrorToast("Please enter City for one-time shipping.");
        setIsSubmitInvoice(false);
        return false;
      }
      if (!shipState) {
        showErrorToast("Please select State for one-time shipping.");
        setIsSubmitInvoice(false);
        return false;
      }
      if (!shipCountry) {
        showErrorToast("Please select Country for one-time shipping.");
        setIsSubmitInvoice(false);
        return false;
      }
    }
    setContactValidationError("");
    setShipContactValidationError("");
    if (
      parseFloat(formData?.deposit || 0) > 0 &&
      (!paymentmethod || paymentContactBased.length === 0)
    ) {
      setPaymentError(true);
      return false;
    }
    setPaymentError(false);
    if (
      paymentmethod === "Trade" &&
      !tradeInventory &&
      !inventoryid &&
      !tradeAutoValue
    ) {
      setInventoryError(
        "Please select atleast one existing inventory to proceed!",
      );
      setIsSubmitInvoice(false);
      return false;
    }
    setInventoryError("");
    setIsSubmitInvoice(true);
    setSaletaxOpen(false);
    let isTaxCheck = salesTaxId ? true : false;
    let isTotalinvoiceCheck = invoiceAmount ? true : false;
    let imageNotAvailable = isConvertToSale
      ? rows?.filter((row) => row.checked).map((row) => ({ ...row, image: [] }))
      : rows?.map((row) => ({ ...row, image: [] }));
    const isTrade = paymentmethod?.toLowerCase() === "trade";
    const isExistingInventorySelected =
      tradeInventory === false && !!TradeInventoryId;
    const hasDeposit = deposit > 0;

    const shouldSendEventRequestChanged =
      isTrade && isExistingInventorySelected && hasDeposit;
    const data = {
      userId: userId,
      accountid: accountId,
      billingcontactid: billContactId,
      shippingcontactid: isSameAddress ? billContactId : isOnetimeShippingAddress ? null : shipContactId,
      isTaxCheck: isTaxCheck,
      isTotalinvoiceCheck: isTotalinvoiceCheck,
      amountExceedreason: reason,
      salestaxSkipReason: salestaxSkipReason,
      billingToBusinessName: formData?.billingToBusinessName,
      billingToName: formData?.billingToName,
      billingToAddressLine1: formData?.billingToAddressLine1,
      billingToAddressLine2: formData?.billingToAddressLine2
        ? formData?.billingToAddressLine2
        : "",
      billingToPhoneNo: formData?.billingToPhoneNo
        ? formData?.billingToPhoneNo
        : "",
      billingToCountryCode: billingCountryCode,
      billingToEmail: formData?.billingToEmail || "",
      billingToCity: formData?.billingToCity || "",
      billingToState: formData?.billingToState
        ? formData?.billingToState.toString().trim()
        : "",
      billingToCountry: formData?.billingToCountry
        ? formData?.billingToCountry.toString().trim()
        : "",
      billingToZip: formData?.billingToZip || "",
      // is_include_temp_walkin_contact: !isWalkInContactSelected,
      is_include_temp_walkin_contact: isBillWalkIn && !isWalkInContactSelected,
      is_include_temp_walkin_contact_ship: isSameAddress
        ? false
        : isShipWalkIn && !isShipWalkInContactSelected,
      is_include_dealercontact: billSearchType === "dealer_name",
      ...(isBillDealer
        ? {
          billing_dealercontact_accountid: dealerAccountId,
          billing_dealercontact_userid: dealerUserId,
        }
        : {
          shippingToBusinessName: formData?.shippingToBusinessName || "",
          shippingToName: formData?.shippingToName || "",
          shippingToAddressLine1: formData?.shippingToAddressLine1 || "",
          shippingToAddressLine2: formData?.shippingToAddressLine2
            ? formData?.shippingToAddressLine2
            : "",
          shippingToPhoneNo: formData?.shippingToPhoneNo
            ? formData?.shippingToPhoneNo
            : "",
          shippingToCountryCode: shippingCountryCode,
          shippingToEmail: formData?.shippingToEmail || "",
          shippingToCity: formData?.shippingToCity || "",
          shippingToState: formData?.shippingToState
            ? formData?.shippingToState.toString().trim()
            : "",
          shippingToCountry: formData?.shippingToCountry
            ? formData?.shippingToCountry.toString().trim()
            : "",
          shippingToZip: formData?.shippingToZip || "",
        }),
      shippingToBusinessName: formData?.shippingToBusinessName || "",
      shippingToName: formData?.shippingToName || "",
      shippingToAddressLine1: formData?.shippingToAddressLine1 || "",
      shippingToAddressLine2: formData?.shippingToAddressLine2
        ? formData?.shippingToAddressLine2
        : "",
      shippingToState: formData?.shippingToState
        ? formData?.shippingToState.toString().trim()
        : "",
      shippingToCountry: formData?.shippingToCountry
        ? formData?.shippingToCountry.toString().trim()
        : "",
      shippingToPhoneNo: formData?.shippingToPhoneNo
        ? formData?.shippingToPhoneNo
        : "",
      shippingToCountryCode: shippingCountryCode,
      shippingToEmail: formData?.shippingToEmail || "",
      shippingToCity: formData?.shippingToCity || "",
      shippingToState: formData?.shippingToState || "",
      shippingToCountry: formData?.shippingToCountry || "",
      shippingToZip: formData?.shippingToZip || "",
      productDetails: JSON.stringify(imageNotAvailable),
      shippingPrice: formData?.shippingPrice
        ? formatPrice(formData?.shippingPrice)
        : "0.00",
      discount: formData?.discount ? formatPrice(formData?.discount) : "0.00",
      tax: formData?.tax ? formatPrice(formData?.tax) : "0.00",
      fees: formData?.fees ? formatPrice(formData?.fees) : "0.00",
      // 'taxId': formData?.taxId ? formData?.taxId : "0.00",
      deposit: formData?.deposit ? formatPrice(formData?.deposit) : "0.00",
      old_amount: formatPrice(String(oldDeposit)),
      terms: formData?.terms,
      paymentMethod: paymentmethod,
      paymentmethod_details: paymentdetails,
      shippingMethod: formData?.shippingMethod,
      shippingDate: shippingDate,
      soldDate: soldDate
        ? formatDate(soldDate, "MM/DD/YYYY", false)
        : formatDate(new Date(), "MM/DD/YYYY", false),
      trackingNumber: formData?.trackingNumber,
      notes: notes,
      wireDetails: wireDetails,
      zelleDetails: zelleDetails,
      venmoDetails: venmoDetails,
      shippingDetails: shippingDetails,
      isSameAddress: isSameAddress,
      isOnetimeShippingAddress: isSameAddress ? false : isOnetimeShippingAddress,
      invoiceType: watchType,
      ...(shouldSendEventRequestChanged
        ? {
          eventrequestchanged: {
            is_purchesd_price_edit: true,
            from: tradeInventoryPrice,
            to: formatPrice(formData?.deposit),
          },
        }
        : {}),
      ...(paymentmethod === "Trade"
        ? {
          isOldTrade: !tradeInventory ? true : false,
          oldTradeInventoryId:
            !tradeInventory && TradeInventoryId ? TradeInventoryId : null,
          ...(shouldSendEventRequestChanged
            ? {
              old_purchase_price: tradeInventoryPrice,
              purchase_price: formatPrice(formData?.deposit),
              purchaseprice: formatPrice(formData?.deposit),
            }
            : {}),
        }
        : {}),
      productId: tradeProductId,
      model: tradeModel,
      serialNo: tradeSerialNumber,
      modelNo: tradeModelNumber,
      modelName: tradeModelName,
      miscCategory: tradeMiscCategory,
      ...(isConvertToSale && { memoId: id }),
    };
    createNewInvoiceAPI(data, billSearchType === "dealer_name");
    // let contactValidation = [
    //   {
    //     userId: userId,
    //     billingToBusinessName: formData?.billingToBusinessName,
    //     billingToName: formData?.billingToName,
    //     billingToAddressLine1: formData?.billingToAddressLine1,
    //     billingToAddressLine2: formData?.billingToAddressLine2,
    //     billingToPhoneNo: formData?.billingToPhoneNo
    //       ? formData?.billingToPhoneNo
    //       : null,
    //     billingToCountryCode: billingCountryCode,
    //     billingToEmail: formData?.billingToEmail,
    //     billingToCity: formData?.billingToCity,
    //     billingToState: formData?.billingToState,
    //     billingToCountry: formData?.billingToCountry,
    //     billingToZip: formData?.billingToZip,
    //     type: "billing",
    //   },
    //   {
    //     userId: userId,
    //     shippingToBusinessName: formData?.shippingToBusinessName,
    //     shippingToName: formData?.shippingToName,
    //     shippingToAddressLine1: formData?.shippingToAddressLine1,
    //     shippingToAddressLine2: formData?.shippingToAddressLine2,
    //     shippingToPhoneNo: formData?.shippingToPhoneNo
    //       ? formData?.shippingToPhoneNo
    //       : null,
    //     shippingToCountryCode: shippingCountryCode,
    //     shippingToEmail: formData?.shippingToEmail,
    //     shippingToCity: formData?.shippingToCity,
    //     shippingToState: formData?.shippingToState,
    //     shippingToCountry: formData?.shippingToCountry,
    //     shippingToZip: formData?.shippingToZip,
    //     type: "shipping",
    //   },
    // ];
    // props.checkContactInDB(contactValidation, (success, error) => {
    //   if (error) {
    //     console.log(error);
    //     setIsSubmitInvoice(false);
    //     toast("Invoice creation failed", {
    //       autoClose: 2000,
    //       type: toast.TYPE.ERROR,
    //       position: toast.POSITION.BOTTOM_CENTER,
    //     });
    //   } else {
    //     const filterNewData = success.data.filter(
    //       (item) => item.isPresent === false
    //     );
    //     const filterExistingData = success.data.filter(
    //       (item) => item.isPresent === true
    //     );
    //     let isNeedConfirmationModal = false;
    //     filterExistingData.map((input) => {
    //       const isChanged = isTwoAddressSame(
    //         data,
    //         input.contactData ? input.contactData[0] : null,
    //         input.type
    //       );
    //       input.isChanged = isChanged;
    //       if (isChanged) {
    //         isNeedConfirmationModal = true;
    //       }
    //     });
    //     if (!isSameAddress) {
    //       if (filterNewData.length > 0 && filterExistingData.length <= 0) {
    //         data["filterData"] = filterNewData;
    //         setModalText(
    //           "This is not in your contacts, Do you want to save it?"
    //         );
    //         setFinalInvoiceData(data);
    //         SetContactListConfirmationModal(!contactListConfirmationModal);
    //       } else if (
    //         filterExistingData.length > 0 &&
    //         filterNewData.length <= 0 &&
    //         isNeedConfirmationModal
    //       ) {
    //         data["filterData"] = filterExistingData;
    //         setModalText("Contact data is changed. Do you want to update it?");
    //         setFinalInvoiceData(data);
    //         SetContactListConfirmationModal(!contactListConfirmationModal);
    //       } else if (
    //         filterNewData.length > 0 &&
    //         filterExistingData.length > 0
    //       ) {
    //         const isChanged = isTwoAddressSame(
    //           data,
    //           filterExistingData[0].contactData[0],
    //           filterExistingData[0].type
    //         );
    //         filterExistingData[0].isChanged = isChanged;
    //         data["filterData"] = filterNewData.concat(filterExistingData);
    //         setModalText(
    //           "This is not in your contacts, Do you want to save it?"
    //         );
    //         setFinalInvoiceData(data);
    //         SetContactListConfirmationModal(!contactListConfirmationModal);
    //       } else {
    //         createNewInvoiceAPI(data);
    //       }
    //     } else if (isSameAddress) {
    //       let isChanged = false;
    //       if (filterExistingData && filterExistingData.length > 0) {
    //         isChanged = isTwoAddressSame(
    //           data,
    //           filterExistingData[0].contactData[0],
    //           filterExistingData[0].type
    //         );
    //       }

    //       if (filterNewData.length > 0) {
    //         data["filterData"] = filterNewData;
    //         setModalText(
    //           "This is not in your contacts, Do you want to save it?"
    //         );
    //         setFinalInvoiceData(data);
    //         SetContactListConfirmationModal(!contactListConfirmationModal);
    //       } else if (filterExistingData.length > 0 && isChanged) {
    //         filterExistingData[0].isChanged = true;
    //         filterExistingData[1].isChanged = true;
    //         data["filterData"] = filterExistingData;
    //         setModalText("Contact data is changed. Do you want to update it?");
    //         setFinalInvoiceData(data);
    //         SetContactListConfirmationModal(!contactListConfirmationModal);
    //       } else {
    //         createNewInvoiceAPI(data);
    //       }
    //     } else {
    //       createNewInvoiceAPI(data);
    //     }
    //   }
    // });
    // console.log(data,"data");
  };

  const handleCloseContactConfirmation = () => {
    setFinalInvoiceData(null);
    SetContactListConfirmationModal(!contactListConfirmationModal);
    createNewInvoiceAPI(finalInvoiceData);
  };

  const handleDealerPushDecision = (isYes) => {
    const isDataPush = isYes ? false : true;
    setDealerPushConfirmOpen(false);
    setIsSubmitInvoice(true);
    props.invoiceDataPush(
      { invoiceId: createdInvoiceId, is_dataPush: isDataPush },
      (error, response) => {
        setIsSubmitInvoice(false);
        if (error) {
          showErrorToast("Failed to push inventory to the dealer account.");
          setCreatedInvoiceId(null);
          return;
        }
        if (response?.status === 1) {
          if (isYes) {
            showSuccessToast(
              "Invoice created and inventory pushed to the buyer's dealer account successfully."
            );
          } else {
            showSuccessToast(
              "Creating Regular Invoice using the Dealer."
            );
          }
        }
        if (isInvoiceQboSynced) {
          setOpenQBOInvoiceModal(true);
        }
        setInvoiceId(createdInvoiceId);
        setCreatedInvoiceId(null);
      },
    );
  };

  const handleSuccessContactConfirmation = () => {
    const data = finalInvoiceData;
    const filterObject = data.filterData;
    setFinalInvoiceData(null);
    SetContactListConfirmationModal(!contactListConfirmationModal);
    filterObject.map((item) => {
      if (!item.isPresent) {
        if (item.type === "billing") {
          data["isBillNew"] = 1;
        } else {
          data["isShipNew"] = 1;
        }
      } else {
        if (item.isChanged && isSameAddress) {
          data["isBillChanged"] = 1;
          data["isShipChanged"] = 1;
        } else if (item.isChanged) {
          if (item.type === "billing") {
            data["isBillChanged"] = 1;
          } else {
            data["isShipChanged"] = 1;
          }
        } else {
          data.isChanged = 0;
        }
      }
    });
    createNewInvoiceAPI(data);
  };

  const viewInvoice = () => {
    localStorage.setItem("tabInvoiceDashboard", "yes");
    props.history.push({
      pathname: "/view/invoice",
      state: { tab: "invoice", invoiceId, invoiceFilter },
    });
    localStorage.removeItem("tabInvoiceDashboard", true);
  };

  const createNewInvoiceAPI = (data, isDealerFlow) => {
    if (data && data.filterData) delete data.filterData;
    props.createInvoiceDetails(
      data,
      (success) => {
        if (success?.status === 3) {
          setIsSubmitInvoice(false);
          setSaletaxOpen(false);

          toast.warning(success?.message || "Invoice warning!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
          if (success?.data?.id) {
            setInvoiceId(success.data.id);
          }
          setOpenQBOInvoiceModal(false);
          return;
        }
        if (success?.status == 0 && success?.errorcode == "STNE") {
          setIsSubmitInvoice(false);
          setSaletaxOpen(true);
          setErrorMessage(
            success?.message ??
            "Sales Tax ID does not exist for the selected contact",
          );
          setErrorCode("STNE");
        } else if (success?.status == 0 && success?.errorcode == "TILE") {
          setIsSubmitInvoice(false);
          setSaletaxOpen(true);
          setErrorMessage(
            success?.message ??
            "Total Invoice amount limit is exceeded for the selected contact",
          );
          setErrorCode("TILE");
        } else if (success?.status === 1) {
          setIsSubmitInvoice(false);
          localStorage.setItem("menuTitle", "INVOICES");
          const isSynced = success?.is_invoice_qbo_synced === true;

          setIsInvoiceQboSynced(isSynced);

          toast("Invoice created successfully", {
            autoClose: 1000,
            type: success.status === 1 ? toast.TYPE.SUCCESS : toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
          if (isDealerFlow && success?.data?.id) {
            setCreatedInvoiceId(success.data.id);
            setDealerPushConfirmOpen(true);
            setSaletaxOpen(false);
            return;
          }

          if (isSynced === true) {
            setOpenQBOInvoiceModal(true);
            setInvoiceId(success?.data?.id);
            return;
          } else {
            setInvoiceId(success?.data?.id);
          }
          setSaletaxOpen(false);
        } else {
          setIsSubmitInvoice(false);
          setSaletaxOpen(false);
          toast(success.message, {
            autoClose: 3000,
            type: toast.TYPE.ERROR,
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      },
      (error) => {
        setIsSubmitInvoice(false);
        setSaletaxOpen(false);
        toast(error?.response?.data?.message || "Invoice creation failed", {
          autoClose: 2000,
          type: toast.TYPE.ERROR,
          position: toast.POSITION.BOTTOM_CENTER,
        });
      },
    );
  };
  const formatPrice = (val) => {
    if (val.includes(".")) {
      if (val.split(".")[1].length > 0) {
        const num = parseFloat(val);
        const cleanNum = num.toFixed(2);
        return cleanNum.toString();
      }
    }
    return `${val}.00`;
  };

  const handleAddRow = (invoiceObj) => {
    if (currentItem) {
      let oldRows = [...rows];
      oldRows[editIdx] = invoiceObj;
      setRows(oldRows);
    } else {
      setRows((prevArray) => [...prevArray, invoiceObj]);
    }
  };

  const onSubmit = (data) => {
    if (type !== "misc_product" && isSerialNumberRequired) {
      errors["serialNumber"] = {
        message: "Please Enter Serial No",
        type: "required",
      };
      return;
    }
    if ((price && Number(price) < amount) || !price) {
      setModalOpen(false);
    } else {
      toast("This sale is under cost", {
        autoClose: 2000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      setModalOpen(false);
    }

    // const amt = parseFloat(data.amount)?.toFixed(2);
    const rowData = {
      ...data,
      amount: parseFloat(data.amount)?.toFixed(2),
      sold_price: parseFloat(data.amount)?.toFixed(2),
      inventoryId: inventoryid,
      productId: productid,
      currency,
      purchaseprice: price,
      type,
      modelNumber: modelNo,
      serialNumber: serial,
      productName: desc || data.productName || "",
      image: image || data.image || imageNotAvailable,
    };
    if (rowData && rowData.from) {
      delete rowData.from;
    }
    handleAddRow(rowData);
    setDesc("");
    setAmount("");
    setpurchaseprice(null);
    setprice(null);
    setModel(null);
    setSerial(null);
    setInventoryId(null);
    setProductId(null);
    reset({
      inventoryid: "",
      serialNumber: "",
      productName: "",
      quantity: 1,
      amount: "",
    });
  };
  const onSubmitone = () => {
    setModalOpen(false);
    // setopenpricewarning(false);
    const amt = parseFloat(onsubmitdata.amount)?.toFixed(2);
    const rowData = onsubmitdata;
    rowData.amount = amt;
    rowData.inventoryId = inventoryid;
    rowData.productId = productid;
    rowData.currency = currency;
    rowData.purchaseprice = price;
    if (rowData && rowData.from) {
      delete rowData.from;
    }
    // rowData.inventoryid = inventoryid;
    // rowData.shippingDate = shippingDate;
    handleAddRow({
      ...rowData,
      ...{ modelNumber: modelNo },
      ...{ serialNumber: serial },
      ...{ productName: desc || getValues("productName") },
    }); // , ...{dueDate}, ...{isInvoiced: invd}, ...{isShipped: shpd}
    setpurchaseprice(null);
    setprice(null);
  };
  const handleTradeInventorySelect = (newValue) => {
    setTradeInventoryId(newValue.inventoryid);
    setTradeAutoValue(newValue);
    setTradeModel(newValue.model);
    setTradeSerialNumber(newValue.serialno);
    setTradeModelName(newValue.technical_details?.product_name);
    setTradeModelNumber(newValue.technical_details?.model_number);
    setTradeInventoryPrice(newValue?.purchaseprice);
    setTradeMiscCategory(newValue.category);
    setTradeWatchType(newValue?.type);
  };
  const handleSameaddressCheck = (event) => {
    const checked = event.target.checked;
    setSameAddress(checked);
    if (checked) {
      setIsOnetimeShippingAddress(false);
      shippingAddress.forEach((item, index) => {
        setValue1(item.id, getValues1(billingAddress[index].id));
      });
      setShipSearchType(billSearchType);
      setValue1("shippingSearchType", billSearchType);
      setShipContactId(billContactId);
      setShipCntctNm(billCntctNm);
      setShippingCountryCode(billingCountryCode);
      setIsShipWalkInContactSelected(isWalkInContactSelected);

      setValue1("shippingToName", getValues1("billingToName"));
      setValue1("shippingToBusinessName", getValues1("billingToBusinessName"));
      setValue1("shippingToPhoneNo", getValues1("billingToPhoneNo"));
      setValue1("shippingToEmail", getValues1("billingToEmail"));
      setValue1("shippingToAddressLine1", getValues1("billingToAddressLine1"));
      setValue1("shippingToAddressLine2", getValues1("billingToAddressLine2"));
      setValue1("shippingToCity", getValues1("billingToCity"));
      setValue1("shippingToState", getValues1("billingToState"));
      setValue1("shippingToCountry", getValues1("billingToCountry"));
      setValue1("shippingToZip", getValues1("billingToZip"));
    } else {
      setShipSearchType("value");
      setValue1("shippingSearchType", "value");
      setShipContactId(null);
      setShipCntctNm(null);
      setIsShipWalkInContactSelected(false);
      shippingAddress.forEach((item) => {
        setValue1(item.id, "");
      });
    }
  };

  const destructureData = (data) => {
    const groupedByEmail = {};
    data.forEach((value) => {
      const Email = value.email;
      groupedByEmail[Email] = groupedByEmail[Email] || [];
      groupedByEmail[Email].push(value);
    });
    const resultArray = Object.values(groupedByEmail);
    return resultArray;
  };

  const handleAddItem = () => {
    setModalOpen(!openModal);
    setCurrentItem(null);
    // setDueDate(null);
    setShippingDate(null);
    setSoldDate(soldDate);
    setAmount(null);
    setInventoryId(null);
    setProductId(null);
    setCurrency("USD");
    setQtyShrink(true);
    setDescShrink(false);
    setEditIdx(null);
    setModel(null);
    setSerial(null);
    setSearchInputmodelno("");
    setSearchInputserialno("");
    setSearchObj({});
    setModelList([]);
    setSerialList([]);
    setAnchorEl(null);
    setAnchorTarget(null);
    setNoData(false);
    setCurrentSearch(null);
    setInventoryId(null);
    setProductId(null);
    setSelectedInventoryModel("");
    setSelectedInventorySerial("");
    setSelectedInventoryModelName("");
    setSelectInventoryModelNumber("");
    setSelectedInventoryCategory("");
    setImage(null);
    setDesc("");
    setAmount("");
    setprice(null);
    setpurchaseprice(null);
    setSearchObj({});
    setModelList([]);
    setSerialList([]);
    setAnchorEl(null);
    setShipAnchorEl(null);
    setAnchorTarget(null);
    setNoData(false);
    setDesc(null);
    setNoData(false);
    setQuantity(1);
    setType(null);
    // setDisabled(false);
    if (!tradeInventory) {
      setInventoryId("");
      setProductId("");
      setModel("");
      setSerial("");
      reset({
        inventoryid: "",
        modelNumber: "",
        serialNumber: "",
        image: "",
        product_name: "",
        quantity: 1,
        amount: "",
        productid: "",
        currency: "USD",
        modelAndSerial: null,
      });
    }
    try {
      setValue("modelAndSerial", null);
      setValue("modelNumber", "");
      setValue("serialNumber", "");
      setValue("productName", "");
      setValue("amount", "");
    } catch (e) { }
  };

  const handleClosepriceModal = () => {
    // setopenpricewarning(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    if (currentItem && currentItem.from) {
      handleRemoveSpecificRow(0);
    }
    reset({
      modelAndSerial: null,
      modelNumber: "",
      serialNumber: "",
      inventoryid: "",
      image: "",
      productName: "",
      product_name: "",
      quantity: 1,
      amount: "",
      productid: "",
      currency: "USD",
    });
    setCurrentItem(null);
    setEditIdx(null);

    setModel(null);
    setSerial(null);
    setSearchInputmodelno("");
    setSearchInputserialno("");
    setSearchObj({});
    setModelList([]);
    setSerialList([]);
    setAnchorEl(null);
    setAnchorTarget(null);
    setNoData(false);
    setCurrentSearch(null);
    setDesc(null);
    setQuantity(1);
    setInventoryId(null);
    setProductId(null);
    setImage(null);
    setAmount("");
    setprice(null);
    setpurchaseprice(null);
    setType(null);
    setSelectedInlineInventoryIds([]);
    setSelectedInventoryModel("");
    setSelectedInventorySerial("");
    setSelectedInventoryModelName("");
    setSelectInventoryModelNumber("");
    setSelectedInventoryCategory("");
    setISSerialNumberRequired(false);
  };

  const handleRemoveSpecificRow = (idx) => {
    setEditIdx(null);
    const temp = [...rows];
    temp.splice(idx, 1);
    if (temp.length === 0) {
      setShipping(null);
      setDeposit(null);
      setTax(null);
      setDeposit(null);
      setQuantity(1);
      setType(null);
      setISSerialNumberRequired(false);
    }
    setRows(temp);
  };

  const onChangeOfCheckBox = (event) => {
    if (event.target.checked === true) {
      setWireDetails(true);
    } else {
      setWireDetails(false);
    }
  };
  const onChangeOfCheckBoxZelle = (event) => {
    if (event.target.checked === true) {
      setZelleDetails(true);
    } else {
      setZelleDetails(false);
    }
  };
  const onchangeshipping = (event) => {
    if (event.target.checked === true) {
      setShippingDetails(true);
    } else {
      setShippingDetails(false);
    }
  };
  const onChangeOfCheckBoxVenmo = (event) => {
    if (event.target.checked === true) {
      setVenmoDetails(true);
    } else {
      setVenmoDetails(false);
    }
  };
  const onChangeOfCheckBoxInventory = (e) => {
    const checked = e.target.checked;
    setTradeInventory(checked);

    if (checked) {
      setTradeAutoValue(null);
      setSearchText("");
      setTradeInventoryId(null);
      setTradeWatchType("");
      setTradeModel("");
      setTradeSerialNumber("");
      setTradeModelName("");
      setTradeModelNumber("");
      setTradeInventoryPrice("");
      setTradeMiscCategory("");

      setValue1("tradeModel", "");
      setValue1("tradeSerialNumber", "");
      setValue1("tradeModelName", "");
      setValue1("tradeModelNumber", "");
      setValue1("tradeMiscCategory", "");
    }
  };
  const handleSearch = (e, column) => {
    setNoData(false);
    const modelNmTrim = e.target.value.trimStart();
    // setAnchorTarget(e.currentTarget);
    setCurrentSearch(column);
    if (column === "modelNumber") {
      setModel(e.target.value);
      setSearchInputmodelno(modelNmTrim);
    } else {
      setSerial(modelNmTrim.length === 0 ? null : e.target.value);
      setSearchInputserialno(modelNmTrim);
      if (type !== "misc_product" && modelNmTrim.length === 0) {
        setISSerialNumberRequired(true);
      } else {
        setISSerialNumberRequired(false);
      }
    }
    setSearchObj({ column, searchVal: e.target.value });
  };

  const handleTradeSearch = (e, column) => {
    const { value } = e.target;
    setTradeModel(value);
    setTradeProductId(null);
    const string = value
      ? value.replace(/[&\/\\#,+!@^&()$~%.'":;*?<>{}]/g, "")
      : "";
    setTradeSerialNumber("");
    setValue1("tradeSerialNumber", "");
    setSearchTradeObj({
      column,
      searchVal: value,
      searchText: string,
      from: "trade",
    });
  };

  const handleTradeSelection = (val, columnId) => {
    setTradeModel(val.model);
    setValue("tradeModel", val.model);
    setTradeProductId(val.productid);
    setPropsModelList([]);
    setSearchTradeObj((prevState) => ({
      ...prevState,
      searchVal: "",
      searchText: "",
      from: "trade",
    }));
  };

  const handleVisibleChange = (visible) => {
    setIsPopoverVisiblebill(visible);
  };
  const handleVisibleChangeship = (visible) => {
    setIsPopoverVisibleship(visible);
  };

  const getInvoiceList = () => {
    getUserdetailsforsubscrption.getAllInvoiceList(
      accountId,
      (error, response) => {
        if (response && response.status == 1) {
          const raw = response.data || [];
          const cleaned = raw.filter((o) => {
            if (!o || typeof o !== "object") return false;
            const hasUseful =
              (o.model && String(o.model).trim()) ||
              (o.serialno && String(o.serialno).trim()) ||
              (o.inventoryid && String(o.inventoryid).trim()) ||
              (o.productid && String(o.productid).trim()) ||
              (o.productId && String(o.productId).trim());
            return !!hasUseful;
          });

          const normalized = cleaned.map((item) => {
            const inventoryid =
              item.inventoryid || item.inventoryId || item.id || null;
            const model =
              item.model && String(item.model).trim()
                ? item.model
                : item.inventory_title ||
                item.modelname ||
                item?.technical_details?.product_title ||
                item?.technical_details?.product_name ||
                "";
            const serialno = item.serialno || item.serial || "";
            const productid =
              item.productid || item.productId || item.product_id || null;
            // const type = inventoryid ? "automatic" : item.type || null;
            const type = item.type || null;

            return {
              ...item,
              inventoryid: inventoryid,
              productid: productid,
              model: model,
              serialno: serialno,
              type: type,
            };
          });

          setInvoiceListData(normalized);
        }
      },
    );
  };

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //   if (
  //     !isBillTextInput &&
  //     billCntctSearchTxt &&
  //     billCntctSearchTxt?.length > 2
  //   ) {
  //     setFieldLoaderBill(true);
  //     // const search = { type: "bill", searchVal: billCntctSearchTxt };
  //     let payload = {
  //       key: billCntctSearchTxt,
  //       contacttype: contactTypeBill,
  //       type: null,
  //       accountids: [accountId],
  //     };
  //     // props.getBillShipContactList(search, userId);
  //     props.getInvoiceNewContactList(payload)
  //       .then(() => {
  //         setFieldLoaderBill(false);
  //       })
  //       .catch((error) => {
  //         setFieldLoaderBill(false);
  //       });
  //   }
  //   // }, 500);
  //   // return () => clearTimeout(timer);
  // }, [billCntctSearchTxt]);

  // useEffect(() => {
  //   // const timer = setTimeout(() => {
  //   if (
  //     !isShipTextInput &&
  //     shipCntctSearchTxt &&
  //     shipCntctSearchTxt?.length > 2
  //   ) {
  //     setFieldLoaderShip(true);
  //     // const search = { type: "ship", searchVal: shipCntctSearchTxt };
  //     let payload = {
  //       key: shipCntctSearchTxt,
  //       contacttype: contactTypeShip,
  //       type: null,
  //       accountids: [accountId],
  //     };
  //     // props.getBillShipContactList(search, userId);
  //     props.getInvoiceNewContactList(payload)
  //       .then(() => {
  //         setFieldLoaderShip(false);
  //       })
  //       .catch((error) => {
  //         setFieldLoaderShip(false);
  //       });
  //   }
  //   // }, 500);
  //   // return () => clearTimeout(timer);
  // }, [shipCntctSearchTxt]);

  const handleContactSearch = (e, column, type) => {
    const CntctNmTrim = e.target.value.trimStart();
    if (type === "bill") {
      setContactValidationError("");
    } else if (type === "ship") {
      setShipContactValidationError("");
    }
    if (type === "bill" && column === "billingToName") {
      setBillCntctNm(CntctNmTrim);
      setSearchInput(CntctNmTrim.trim());
      setValue1("billingToName", CntctNmTrim);
      if (isSameAddress) {
        setShipCntctNm(CntctNmTrim);
      }
      if (billSearchType === "walk_in") {
        setIsWalkInContactSelected(false);
        setPaymentContactBased([
          "Affirm",
          "Cash",
          "Check",
          "Credit Card",
          "Crypto",
          "Paypal",
          "Scrap Gold",
          "Trade",
          "Venmo",
          "Wire",
          "Zelle",
        ]);
      }
      if (billSearchType === "dealer_name") {
        if (CntctNmTrim.trim().length >= 3) {
          triggerDealerSearch(CntctNmTrim.trim());
        } else {
          setDealerList([]);
          setIsPopoverVisibleDealer(false);
        }
      } else {
        setBillCntctSearchTxt(CntctNmTrim);
        setShipCntctSearchTxt(null);
        setFieldLoaderBill(CntctNmTrim.trim().length > 2);
      }
    } else if (type === "ship" && column === "shippingToName") {
      setShipCntctNm(CntctNmTrim);
      setSearchInputship(CntctNmTrim.trim());
      setValue1("shippingToName", CntctNmTrim);
      if (isOnetimeShippingAddress) {
        setShipCntctSearchTxt(null);
        setShipCntcts([]);
        setIsPopoverVisibleship(false);
        setFieldLoaderShip(false);
        setBillCntctSearchTxt(null);
        return;
      }
      if (shipSearchType === "walk_in") {
        setIsShipWalkInContactSelected(false);
        // setShipCntctSearchTxt(null);
      }
      setShipCntctSearchTxt(CntctNmTrim);
      setBillCntctSearchTxt(null);
      setFieldLoaderShip(CntctNmTrim.trim().length > 2);
    }
    if (type === "bill" && isSameAddress) {
      const changeColum = column.split("billing")[1];
      setValue1(`shipping${changeColum}`, CntctNmTrim, { shouldDirty: true });
      forceShipLabelUpdate((n) => n + 1);
    }
  };

  const handleContactTypeChange = (event, type) => {
    const { value, checked } = event.target;
    if (type === "bill") {
      setContactTypeBill((prev) =>
        checked ? [...prev, value] : prev.filter((type) => type !== value),
      );
      setClassificationTypeBill((prev) => (checked ? null : prev));
    } else if (type === "ship") {
      setContactTypeShip((prev) =>
        checked ? [...prev, value] : prev.filter((type) => type !== value),
      );
      setClassificationTypeShip((prev) => (checked ? null : prev));
    }
  };

  const handleSearchTypeChange = (value, type) => {
    if (type === "bill") {
      if (billSearchType === "walk_in" && value === "other_option") {
        applyTaxFieldValue(null);
      }
      setBillSearchType(value);
      setIsWalkInContactSelected(false);
      clearErrors1("billingToBusinessName");
      // Reset bill contact search state
      setBillCntctNm(null);
      setBillCntctSearchTxt(null);
      setSearchInput("");
      setBillCntctLst([]);
      setValue1("billingToName", "");
      setDealerList([]);
      setIsPopoverVisibleDealer(false);
      setBillContactId(null);
      setDealerAccountId(null);
      setDealerUserId(null);
      setValue1("billingToBusinessName", "");
      setValue1("billingToPhoneNo", "");
      setBillingCountryCode("+1");
      setValue1("billingToEmail", "");
      setValue1("billingToAddressLine1", "");
      setValue1("billingToAddressLine2", "");
      setValue1("billingToCity", "");
      setValue1("billingToCountry", "United States");
      setValue1("billingToState", "");
      setValue1("billingToZip", "");
      forceBillLabelUpdate((n) => n + 1);
      setPaymentMethod(null);
      setPaymentContactBased([]);
      setPaymentError(false);
      setClassificationType("");
      setContactType("");
      handleNonTrade();
      setWatchType("standard_watch");
      setShipCntctNm(null);
      setShipCntctSearchTxt(null);
      setSearchInputship("");
      setShipCntcts([]);
      setShipContactId(null);
      setValue1("shippingToName", "");
      shippingAddress.forEach((item) => {
        setValue1(item.id, "");
      });
      if (isSameAddress) {
        setShipSearchType(value);
        setValue1("shippingSearchType", value);
        setIsShipWalkInContactSelected(false);
      }
      // setSameAddress(false);
    } else if (type === "ship") {
      setShipSearchType(value);
      setShipCntctNm(null);
      setShipCntctSearchTxt(null);
      setSearchInputship("");
      setShipCntcts([]);
      setIsShipWalkInContactSelected(false);
      clearErrors1("shippingToBusinessName");
      setValue1("shippingToName", "");
    }
  };

  const clearSearchInput = () => {
    setModel(null);
    setSerial(null);
    setDesc(null);
    setAnchorEl(null);
    setSearchInputmodelno("");
    setSearchInputserialno("");
    setAnchorTarget(null);
    setModelList([]);
    setSerialList([]);
    setCurrentItem(null);
    setCurrency("USD");
    setDescShrink(false);
    setNoData(false);
    setType(null);
    setISSerialNumberRequired(false);
    setSearchObj((prevState) => ({ ...prevState, searchVal: "" }));
    reset({ modelNumber: null, serialNumber: null, productName: null });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSalesTaxModalClose = () => {
    setSaletaxOpen(false);
    setReason(null);
    setSalestaxSkipReason(null);
    setErrorCode(null);
    setErrorMessage(null);
  };

  const handleNavigate = () => {
    window.open(
      `${window.location.origin}/contactmanagement/edit/${billContactId}`,
      "_blank",
    );
  };

  const handleFocus = () => {
    setSaletaxOpen(false);
    setTimeout(() => {
      const taxInput = document.querySelector("#taxInput");
      if (taxInput) {
        taxInput.scrollIntoView({ behavior: "smooth", block: "center" });
        taxInput.focus();
      }
    }, 100);
  };

  const handleSelection = (val, columnId) => {
    const model =
      val?.model && val?.model !== null
        ? val?.model
        : val?.technical_details?.product_title
          ? val?.technical_details?.product_title
          : val?.technical_details?.product_name;
    const product_name = getInventoryProductName(val);
    setModel(model);
    setSerial(val?.serialno);
    setpurchaseprice(val?.purchaseprice);
    setprice(val?.purchaseprice);
    setSelectedInventoryModel(val?.model || "");
    setSelectedInventorySerial(val?.serialno || "");
    setSelectedInventoryModelName(val?.technical_details?.product_name || "");
    setSelectInventoryModelNumber(val?.technical_details?.model_number || "");
    setSelectedInventoryCategory(val?.category || "");
    // setDesc(val.description); // todo while fixing productname strink issue we changed this
    setDesc(product_name);
    const selectedImage = getInventoryDisplayImage(val);
    setImage(selectedImage);
    setQuantity(val?.quantity);
    setType(val?.type);
    const finalType = val?.type
      ? val.type === "misc_watch" || val.type === "misc_product"
        ? val.type
        : "standard_watch"
      : "standard_watch";
    setWatchType(finalType);
    setISSerialNumberRequired(false);
    setProductId(val?.productid);
    setAnchorEl(null);
    setAnchorTarget(null);
    setValue("modelNumber", model);
    setValue("serialNumber", val?.serialno);
    setInventoryId(val?.inventoryid);
    setTimeout(() => {
      setValue("productName", product_name);
    }, 100);
    setValue("image", selectedImage);
    setDescShrink(product_name ? true : false);
    setSearchObj((prevState) => ({ ...prevState, searchVal: "" }));
    setModelList([]);
    setSerialList([]);
    setSearchInputmodelno("");
    setSearchInputserialno("");
  };

  const clearCntctSearchInput = (type) => {
    if (type === "bill") {
      setNoBillData(false);
      setBillCntctLst([]);
      setBillCntctSearchTxt(null);
      setSearchInput("");
      setBillCntctNm(null);
      setBillContactId(null);
      setBillingCountryCode("");
      setDealerAccountId(null);
      setDealerUserId(null);
      setPaymentMethod(null);
      setPaymentError(false);
      setIsWalkInContactSelected(false);
      if (isSameAddress) {
        setNoShipData(false);
        setShipCntctSearchTxt(null);
        setSearchInputship("");
        setShipCntctNm(null);
        reset1();
        setShipContactId(null);
        setShippingCountryCode("");
        setIsShipWalkInContactSelected(false);
        forceBillLabelUpdate((n) => n + 1);
      } else {
        setValue1("billingToName", null);
        setValue1("billingToBusinessName", null);
        setValue1("billingToPhoneNo", null);
        setValue1("billingToEmail", null);
        setValue1("billingToAddressLine1", null);
        setValue1("billingToAddressLine2", null);
        setValue1("billingToCity", null);
        setValue1("billingToState", null);
        setValue1("billingToCountry", "United States");
        setValue1("billingToZip", null);
        forceBillLabelUpdate((n) => n + 1);
        if (billSearchType === "dealer_name") {
          setShipCntctNm(null);
          setValue1("shippingToName", null);
          setValue1("shippingToBusinessName", null);
          setValue1("shippingToPhoneNo", null);
          setValue1("shippingToEmail", null);
          setValue1("shippingToAddressLine1", null);
          setValue1("shippingToAddressLine2", null);
          setValue1("shippingToCity", null);
          setValue1("shippingToState", null);
          setValue1("shippingToCountry", "United States");
          setValue1("shippingToZip", null);
          setShipContactId(null);
          setShippingCountryCode("");
        }
      }
    } else {
      setNoShipData(false);
      setShipCntcts([]);
      setSearchInputship("");
      setShipCntctSearchTxt(null);
      setShipCntctNm(null);
      setIsShipWalkInContactSelected(false);
      setValue1("shippingToName", null);
      setValue1("shippingToBusinessName", null);
      setValue1("shippingToPhoneNo", null);
      setValue1("shippingToEmail", null);
      setValue1("shippingToAddressLine1", null);
      setValue1("shippingToAddressLine2", null);
      setValue1("shippingToCity", null);
      setValue1("shippingToState", null);
      setValue1("shippingToCountry", "United States");
      setValue1("shippingToZip", null);
      setSameAddress(false);
      setShipContactId(null);
      setShippingCountryCode("");
    }
  };

  //   const changeTextMode = (type)=>{
  //       if(type ==="bill") {
  //         setIsBillTextInput(!isBillTextInput);
  //         setNoBillData(false);
  //       } else {
  //         setIsShipTextInput(!isShipTextInput);
  //         setNoShipData(false);
  //       }
  //   }
  const onchangeDeposit = (e) => {
    let value = e.target.value;

    if (paymentmethod === "Trade") {
      value = value.replace(/[^0-9.-]/g, "");

      const firstDash = value.indexOf("-");
      if (firstDash > 0) {
        value = value.replace("-", "");
      }
      if ((value.match(/-/g) || []).length > 1) {
        value = value.replace(/-/g, "-").replace(/-(?=.)/g, "");
      }

      const dotParts = value.split(".");
      if (dotParts.length > 2) {
        value = dotParts[0] + "." + dotParts.slice(1).join("");
      }
    } else {
      value = value.replace(/[^0-9.]/g, "");

      const dotParts = value.split(".");
      if (dotParts.length > 2) {
        value = dotParts[0] + "." + dotParts.slice(1).join("");
      }
    }

    setDeposit(value);

    const method = getValues1("payment_method");
    if (parseFloat(value) > 0 && !method) {
      setPaymentError(true);
    } else {
      setPaymentError(false);
    }
    if (parseFloat(value) > 0) {
      setDepositAmountError("");
    }
  };

  const validateDeposit = (
    value,
    rows,
    getValues1,
    isConvertToSale,
    paymentmethod,
  ) => {
    const depositValue = parseFloat(value || "0");
    if (paymentmethod === "Trade") {
      return true;
    }

    if (depositValue < 0) {
      return "This Payment Method does not accept negative values";
    }

    const selectedRows = isConvertToSale
      ? rows.filter((item) => item.checked)
      : rows;

    const totalItemAmount = selectedRows.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0,
    );

    const tax = parseFloat(getValues1("tax") || "0");
    const fees = parseFloat(getValues1("fees") || "0");
    const shipping = parseFloat(getValues1("shippingPrice") || "0");
    const discount = parseFloat(getValues1("discount") || "0");
    const maxDeposit = totalItemAmount + tax + fees + shipping - discount;

    // if (Math.abs(depositValue) > maxDeposit) {
    //   return "Deposit should not exceed the total invoice amount (inventory amount + shipping + tax + fees - discount)";
    // }
    return true;
  };

  const handlePaymentMethod = (event) => {
    const { value } = event.target;
    setPaymentMethod(value);
    if (value !== "Trade") {
      handleNonTrade();
      clearTradeFields();
    } else {
      initializeTradeFields();
    }
    setPaymentError(false);
  };

  const handleNonTrade = () => {
    setTradeModel(null);
    updateTradeSerialNumber(null);
    setTradeModelName(null);
    setTradeModelNumber(null);
    setTradeInventoryPrice(null);
    setTradeMiscCategory(null);
  };
  // Clear other fields if needed
  const clearTradeFields = () => {
    updateTradeSerialNumber(null);
  };
  // when it is trade this would be called
  const initializeTradeFields = () => {
    if (watchType === "misc_watch" && !tradeSerialNumber) {
      updateTradeSerialNumber(createTradeMiscWatchSerialNumber());
    }
  };

  const handleOpenCreateContactModal = (target) => {
    setCreateContactTarget(target);
    setCreateContactModalOpen(true);
  };

  const handleCreateContactSuccess = (contact) => {
    if (!contact) return;
    if (!contact.contactid) {
      showErrorToast(
        "Contact was created, but it could not be linked to the invoice. Please search and select the new contact.",
      );
      return;
    }
    handleContactSelection(contact, createContactTarget || "bill");
  };

  const handleContactSelection = async (val, columnId) => {
    const displayName =`${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim() ||(val?.businessname || "").trim() ||"";
    if (columnId === "bill") {
      setNoBillData(false);
      setBillCntctNm(displayName);
      setBillCntctSearchTxt("");
      setBillCntctLst([]);
      setSearchInput("");
      setSearchInputship("");
      setClassificationType(val?.classification_type);
      setPaymentContactBased(
        val.acceptable_payment && val.acceptable_payment.length > 0
          ? val.acceptable_payment
          : [],
      );
      setValue1("terms", val.paymentterm ? val.paymentterm : "Immediate", {
        shouldValidate: true,
        shouldDirty: true,
      });
      if (val.billingcountry) {
        const selectedCountry = val.billingcountry;
        const filterCountry = countryListData.find(
          (country) => country.name === selectedCountry,
        );
        if (filterCountry && filterCountry.id) {
          getUserdetailsforsubscrption
            .getAllStateList(filterCountry.id)
            .then((res) => {
              setStatesListData(res?.data?.data);
            })
            .catch((error) => {
              // console.error("getAllStateList failed for country id:", filterCountry.id, error);
              setStatesListData([]);
              showErrorToast("Unable to load states for this contact's country");
            });
        } else {
          setStatesListData([]);
        }
      }
      let phoneNumber = val ? val.phoneno : null;
      if (phoneNumber && val.billingcountry) {
        phoneNumber = phoneNumber.replace(/\W+/g, "");
      }
      setBillingCountryCode(val?.phonecountrycode || "+1");
      setBillContactId(val?.contactid);
      setValue1("billingToName", displayName, {
        shouldValidate: true,
        shouldDirty: true,
      });
      setValue1("billingToBusinessName", val?.businessname || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      setValue1("billingToPhoneNo", phoneNumber || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      setValue1("billingToEmail", val?.emailid || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      setValue1("billingToAddressLine1", val?.billingaddress1 || "", {
        shouldDirty: true,
      });
      setValue1("billingToAddressLine2", val?.billingaddress2 || "", {
        shouldDirty: true,
      });
      setValue1("billingToCity", val?.billingcity || "", {
        shouldDirty: true,
      });
      setValue1(
        "billingToState",
        canonicalOptionName(val?.billingstate, statesListData, null),
        { shouldDirty: true },
      );
      setValue1(
        "billingToCountry",
        canonicalOptionName(val?.billingcountry, countryListData, null),
        { shouldDirty: true },
      );
      setValue1("billingToZip", val?.billingzipcode || "", {
        shouldDirty: true,
      });
      clearErrors1("billingToName");
      if (billSearchType === "walk_in") {
        setIsWalkInContactSelected(true);
        clearErrors1("billingToBusinessName");
      }
      if (isSameAddress) {
        shippingFormPatch(val);
      }
    } else {
      setNoShipData(false);
      setShipCntctSearchTxt("");
      setSearchInputship("");
      setShipCntcts([]);
      setIsPopoverVisibleship(false);
      shippingFormPatch(val);
    }
  };

  const shippingFormPatch = (val) => {
    const displayName =
      `${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim() ||
      (val?.businessname || "").trim() ||
      "";
    setShipCntctNm(displayName);
    setShipCntctSearchTxt("");
    setSearchInputship("");
    if (val.shippingcountry) {
      const selectedCountry = val.shippingcountry.toString().trim();
      const filterCountry = countryListData.find(
        (country) => country.name?.toLowerCase() === selectedCountry.toLowerCase(),
      );
      if (filterCountry && filterCountry.id) {
        getUserdetailsforsubscrption
          .getAllStateList(filterCountry.id)
          .then((res) => {
            setShippingStatesListData(res?.data?.data || []);
          })
          .catch((error) => {
            // console.error("getAllStateList failed for country id:", filterCountry.id, error);
            setShippingStatesListData([]);
            showErrorToast("Unable to load states for this contact's country");
          });
      } else {
        setShippingStatesListData([]);
      }
    }
    let phoneNumber = val ? val.phoneno : null;
    phoneNumber = phoneNumber ? phoneNumber.replace(/\W+/g, "") : null;
    setShippingCountryCode(phoneNumber ? val?.phonecountrycode || "" : "");
    setShipContactId(val?.contactid);
    setValue1("shippingToName", displayName, {
      shouldValidate: true,
      shouldDirty: true,
    });
    setValue1("shippingToBusinessName", val?.businessname || "", {
      shouldDirty: true,
    });
    setValue1("shippingToPhoneNo", phoneNumber || "", {
      shouldDirty: true,
    });
    setValue1("shippingToEmail", val?.emailid || "", {
      shouldDirty: true,
    });
    setValue1("shippingToAddressLine1", val?.shippingaddress1 || "", {
      shouldDirty: true,
    });
    setValue1("shippingToAddressLine2", val?.shippingaddress2 || "", {
      shouldDirty: true,
    });
    setValue1("shippingToCity", val?.shippingcity || "", {
      shouldDirty: true,
    });
    setValue1(
      "shippingToState",
      canonicalOptionName(val?.shippingstate, shippingStatesListData, null),
      { shouldDirty: true },
    );
    setValue1(
      "shippingToCountry",
      canonicalOptionName(val?.shippingcountry, countryListData, null),
      { shouldDirty: true },
    );
    setValue1("shippingToZip", val?.shippingzipcode || "", {
      shouldDirty: true,
    });
    clearErrors1("shippingToName");
    if (shipSearchType === "walk_in") {
      setIsShipWalkInContactSelected(true);
      clearErrors1("shippingToBusinessName");
    }
  };

  const onChangeCounry = (e, id, type = null) => {
    const selectedCountry = e.target.value;
    const filterCountry = countryListData.find(
      (country) => country.name === selectedCountry,
    );
    if (type) {
      handleContactSearch(e, id, "bill");
      setValue1(
        id,
        selectedCountry ? selectedCountry.toString().trim() : selectedCountry,
      );
      if (filterCountry && filterCountry.id) {
        getUserdetailsforsubscrption
          .getAllStateList(filterCountry.id)
          .then((res) => {
            setStatesListData(res?.data?.data);
            // setBillingCountryCode(filterCountry.phonecode)
          });
      }
    } else {
      setValue1(
        id,
        selectedCountry ? selectedCountry.toString().trim() : selectedCountry,
      );
      if (filterCountry && filterCountry.id) {
        getUserdetailsforsubscrption
          .getAllStateList(filterCountry.id)
          .then((res) => {
            setShippingStatesListData(res?.data?.data);
            // setShippingCountryCode(filterCountry.phonecode)
          });
      }
    }
  };

  // const handleContactAddress = (val) => {
  //   let address = "";
  //   if (val?.contactname) {
  //     address += val?.contactname;
  //   }
  //   if (val?.businessname) {
  //     address += address ? ", " + val?.businessname : val?.businessname;
  //   }
  //   if (val?.address1) {
  //     address += address ? ", " + val?.address1 : val?.address1;
  //   }
  //   if (val?.address2) {
  //     address += address ? ", " + val?.address2 : val?.address2;
  //   }
  //   if (val?.city) {
  //     address += address ? ", " + val?.city : val?.city;
  //   }
  //   if (val?.states) {
  //     address += address ? ", " + val?.states : val?.states;
  //   }
  //   if (val?.country) {
  //     address += address ? ", " + val?.country : val?.country;
  //   }
  //   if (val?.zipcode) {
  //     address += address ? ", " + val?.zipcode : val?.zipcode;
  //   }
  //   return address;
  // };

  const handleContactAddress = (val, type) => {
    if (!val || !type) return "";

    const addressFields =
      type === "bill"
        ? [
          "billingaddress1",
          "billingaddress2",
          "billingcity",
          "billingstate",
          "billingcountry",
          "billingzipcode",
        ]
        : [
          "shippingaddress1",
          "shippingaddress2",
          "shippingcity",
          "shippingstate",
          "shippingcountry",
          "shippingzipcode",
        ];

    const name = `${val?.firstname ?? ""} ${val?.lastname ?? ""}`.trim();
    const fields = [
      name,
      val?.businessname,
      ...addressFields.map((field) => val?.[field]),
    ];

    // Filter out undefined or empty values and join with ", "
    return fields.filter(Boolean).join(", ");
  };

  const handleDescription = (el) => {
    if (el.target.value) {
      setDescShrink(true);
    } else {
      setDescShrink(false);
    }
  };
  const handleCloseQBO = () => {
    setOpenQBOInvoiceModal(false);
    setIsInvoiceQboSynced(true);
    setInvoiceId((prev) => prev);
    viewInvoice();
  };
  const handleGoBack = (invoiceFilter) => {
    history.push({
      pathname: "/invoices",
      state: { invoiceFilter },
    });
  };

  const handleCheckboxChange = (idx) => {
    setRows((prevRows) =>
      prevRows.map((row, index) =>
        index === idx ? { ...row, checked: !row.checked } : row,
      ),
    );
  };


  return (
    <div style={{ backgroundColor: "white" }}>
      <Header />
      <Container
        maxWidth="md"
        style={{ backgroundColor: "white", minHeight: height - 114 + "px" }}
      >
        {isLoading ? (
          <div class="d-spinner">
            <SpinnerRoundFilled
              size={51}
              thickness={125}
              speed={80}
              color="rgba(57, 107, 172, 1)"
              className="spp"
              enabled={isLoading}
            />
          </div>
        ) : (
          <form key={1} onSubmit={handleSubmit1(onCreateInvoiceSubmit)}>
            <Grid container xs={12} sm={12}>
              <h1 style={{ display: "flex", alignItems: "center" }}>
                <ArrowBackIcon
                  style={{
                    color: "action",
                    paddingRight: "15px",
                    fontSize: 40,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    isConvertToSale
                      ? handleGoBack(invoiceFilter)
                      : history.goBack();
                  }}
                >
                  {" "}
                </ArrowBackIcon>
                {isConvertToSale ? "Convert to Sale" : "Create an invoice"}
              </h1>
            </Grid>
            {!isConvertToSale && (
              <Grid
                container
                item
                xs={12}
                sm={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="text"
                  style={{
                    background: "#000",
                    color: "#fff",
                    marginTop: 20,
                    marginBottom: 20,
                  }}
                  onClick={handleAddItem}
                >
                  Add Item
                </Button>
              </Grid>
            )}
            <TableContainer
              sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
            >
              <Table aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {isConvertToSale && (
                      <StyledTableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={
                            rows.length > 0 && rows.every((row) => row.checked)
                          }
                          indeterminate={
                            rows.some((row) => row.checked) &&
                            !rows.every((row) => row.checked)
                          }
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const updated = rows.map((row) => ({
                              ...row,
                              checked,
                            }));
                            setRows(updated);
                          }}
                        />
                      </StyledTableCell>
                    )}

                    {invoiceObj
                      .filter(
                        (item) =>
                          item.id !== "currency" &&
                          item.id !== "modelAndSerial",
                      )
                      .map((column) => (
                        <StyledTableCell key={column.id}>
                          {column.label}
                        </StyledTableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows?.length === 0 && (
                    <StyledTableRow>
                      <TableCell colspan={11} style={{ textAlign: "center" }}>
                        No record found
                      </TableCell>
                    </StyledTableRow>
                  )}
                  {rows?.map((row, idx) => {
                    return (
                      <>
                        <StyledTableRow
                          hover="checkbox"
                          tabIndex={-1}
                          key={row.code}
                        >
                          {isConvertToSale && (
                            <TableCell>
                              <Checkbox
                                checked={row.checked}
                                onChange={() => handleCheckboxChange(idx)}
                              />
                            </TableCell>
                          )}
                          {invoiceObj
                            ?.filter(
                              (item) =>
                                item.id !== "currency" &&
                                item.id !== "modelAndSerial",
                            )
                            .map((column) => {
                              return (
                                <>
                                  {column.id !== "action" && (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{
                                        color:
                                          isConvertToSale &&
                                          (row.checked ? "inherit" : "gray"),
                                      }}
                                    >
                                      {
                                        // (column.id === "isShipped" || column.id === "isInvoiced") ? (row[column.id] ? "Yes" : "No") :
                                        column.type === "image" ? (
                                          <img
                                            src={row[column.id]}
                                            width="35"
                                            height="55"
                                          />
                                        ) : column.id === "rate" ||
                                          column.id === "amount" ? (
                                          `${rows[idx].currency}${row[column.id]
                                          }`
                                        ) : column.id === "productName" &&
                                          row[column.id]?.length > 50 ? (
                                          row[column.id]?.slice(0, 50) + "..."
                                        ) : (
                                          row[column.id]
                                        )
                                      }
                                    </TableCell>
                                  )}
                                  {column.id === "action" && (
                                    <TableCell
                                      key={column.id}
                                      align={column.align}
                                      style={{ padding: 10 }}
                                    >
                                      <Box
                                        style={{
                                          pointerEvents:
                                            isConvertToSale &&
                                            (row.checked ? "auto" : "none"),
                                          opacity:
                                            isConvertToSale &&
                                            (row.checked ? 1 : 0.5),
                                        }}
                                      >
                                        <EditIcon
                                          style={{
                                            cursor: "pointer",
                                            width: "19px",
                                          }}
                                          onClick={() => {
                                            setModalOpen(!openModal);
                                            setAnchorEl(null);
                                            const currentItem = rows.at(idx);
                                            const {
                                              amount,
                                              currency,
                                              modelNumber,
                                              serialNumber,
                                              type,
                                              purchaseprice,
                                              productId,
                                              productName,
                                              inventoryId,
                                            } = currentItem;
                                            setCurrentItem(currentItem);
                                            setCurrency(currency);
                                            reset(currentItem);
                                            setEditIdx(idx);
                                            setModel(modelNumber);
                                            setSerial(serialNumber);
                                            setType(type);
                                            setprice(purchaseprice);
                                            setAmount(amount);
                                            setInventoryId(inventoryId);
                                            setProductId(productId);
                                            setDesc(productName);
                                            if (productName) {
                                              setDescShrink(true);
                                            }
                                          }}
                                        />
                                        &nbsp;&nbsp;&nbsp;
                                        {isConvertToSale ? null : (
                                          <DeleteIcon
                                            style={{
                                              cursor: "pointer",
                                              width: "19px",
                                            }}
                                            onClick={() => {
                                              handleRemoveSpecificRow(idx);
                                            }}
                                          />
                                        )}
                                      </Box>
                                    </TableCell>
                                  )}
                                </>
                              );
                            })}
                        </StyledTableRow>
                      </>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid container style={{ marginBottom: "20px" }}>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <div>
                    <Typography className="color-232323">
                      <Grid
                        container
                        style={{
                          justifyContent: "flex-start",
                          alignItems: "center",
                          height: "42px",
                        }}
                      >
                        <Grid item xs={6} sm={6} md={6}>
                          <b>BILL TO</b>
                        </Grid>
                        {/* <Grid item xs={6} sm={6} md={6}>
                                { !isBillTextInput ?
                                   <Button variant="text" style={{ background: "gray", color: "#fff", fontSize:"12px", padding:"4px" }} onClick={()=>{changeTextMode('bill')}}>Click to Add Contact</Button>
                                   :
                                   <Button variant="text" style={{ background: "gray", color: "#fff", fontSize:"12px", padding:"4px" }} onClick={()=>{changeTextMode('bill')}}>Click to Search Contact</Button>
                                }
                            </Grid>
                            */}
                      </Grid>
                    </Typography>
                  </div>
                  {billingAddress.map((column) => (
                    <>
                      {column.type === "text_search" && (
                        <>
                          <div
                            className="searchInputs"
                            style={{ marginTop: "30px", position: "relative" }}
                          >
                            <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20"
                              style={{ marginBottom: "-10px" }}
                            >
                              {billCntctNm ? (
                                <InputLabel
                                  htmlFor="billCntctNm"
                                  shrink={true}
                                  style={{ color: "#424242" }}
                                >
                                  {billSearchType === "dealer_name" ? "Dealer Name" : "Contact Name"}
                                </InputLabel>
                              ) : null}

                              <AntdInput
                                ref={inputRef}
                                id="billCntctNm"
                                type="text"
                                autoComplete="off"
                                className="invoice-contact-name-input"
                                value={billCntctNm || ""}
                                placeholder={
                                  billSearchType === "dealer_name"
                                    ? "Dealer Name"
                                    : "Contact Name"
                                }
                                {...register1(column.id, {
                                  // required: column.required
                                  // ? column.errMsg
                                  required: false,
                                })}
                                style={{
                                  marginBottom: "0px",
                                  marginTop: billCntctNm ? "10px" : "0px",
                                  fontSize: "16px",
                                  paddingLeft: 0,
                                }}
                                onChange={(e) => {
                                  handleContactSearch(e, column.id, "bill");
                                  if (billSearchType === "dealer_name") {
                                    setIsPopoverVisibleDealer(true);
                                  }
                                }}
                                bordered={false}
                              />
                              {errors[column.id] && (
                                <span style={{ color: "red" }}>
                                  {column.errMsg}
                                </span>
                              )}
                              <Divider style={{ marginTop: "5px" }} />
                              <div className="contactSearchIcon">
                                <Grid container>
                                  <Grid item xs={6} sm={6} md={6}>
                                    {!isBillTextInput && (
                                      <>
                                        {!billCntctNm ? (
                                          <SearchIcon
                                            style={{ cursor: "pointer" }}
                                          />
                                        ) : (
                                          <>
                                            {(fieldLoaderBill || dealerListLoading) ? (
                                              <CircularProgress
                                                style={{
                                                  width: "25px",
                                                  height: "25px",
                                                }}
                                              />
                                            ) : (
                                              <CloseIcon
                                                id="clearBtn"
                                                onClick={() => {
                                                  clearCntctSearchInput("bill");
                                                  setDealerList([]);
                                                  setIsPopoverVisibleDealer(false);
                                                  setDealerListLoading(false);
                                                }}
                                                style={{ cursor: "pointer" }}
                                              />
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                </Grid>
                              </div>
                              {/* <AntdPopover
                                  open={isPopoverVisibleDealer}
                                  content={dealerPopoverContent}
                                  placement="bottomLeft"
                                >
                                  <span />
                                </AntdPopover> */}
                            </FormControl>

                            {billSearchType === "dealer_name" &&
                              !dealerListLoading &&
                              dealerList.length > 0 &&
                              searchInput.length >= 3 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    zIndex: 9999,
                                    background: "#fff",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "4px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    width: "100%",
                                  }}
                                >
                                  {dealerList.map((dealer, index) => {
                                    const bizName = dealer?.businessname || "";
                                    const addr1 = dealer?.addressline1 || "";
                                    const addr2 = dealer?.addressline2 || "";
                                    const city = dealer?.city || "";
                                    const state = dealer?.statename || "";
                                    const country = dealer?.name || "";
                                    const zip = dealer?.zip || "";

                                    const listLabel = [bizName, addr1, addr2, city, state, country, zip]
                                      .filter(Boolean)
                                      .join(", ");
                                    const displayName = bizName;

                                    return (
                                      <div
                                        key={index}
                                        style={{
                                          padding: "10px 12px",
                                          cursor: "pointer",
                                          borderBottom: index < dealerList.length - 1 ? "1px solid #f0f0f0" : "none",
                                          background: "#fff",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                                        onMouseLeave={(e) => (e.currentTarget.style.background = "#fff")}
                                        onClick={() => {
                                          setBillCntctNm(displayName);
                                          setValue1("billingToName", displayName);
                                          setValue1("billingToBusinessName", bizName);
                                          setBillingCountryCode(dealer?.countrycode || "+1");
                                          setValue1("billingToPhoneNo", dealer?.phone || "");
                                          setValue1("billingToEmail", dealer?.email || "");
                                          setValue1("billingToAddressLine1", addr1);
                                          setValue1("billingToAddressLine2", addr2);
                                          setValue1("billingToCity", city);
                                          setValue1("billingToCountry", dealer?.name || "United States");
                                          setValue1("billingToState", dealer?.statename || "");
                                          setValue1("billingToZip", zip);
                                          setBillContactId(null);
                                          setDealerAccountId(dealer?.accountid || null);
                                          setDealerUserId(dealer?.userid || null);
                                          if (isSameAddress) {
                                            setShipCntctNm(displayName);
                                            setValue1("shippingToName", displayName);
                                            setValue1("shippingToBusinessName", bizName);
                                            setShippingCountryCode(dealer?.countrycode || "+1");
                                            setValue1("shippingToPhoneNo", dealer?.phone || "");
                                            setValue1("shippingToEmail", dealer?.email || "");
                                            setValue1("shippingToAddressLine1", addr1);
                                            setValue1("shippingToAddressLine2", addr2);
                                            setValue1("shippingToCity", city);
                                            setValue1("shippingToCountry", dealer?.name || "United States");
                                            setValue1("shippingToState", dealer?.statename || "");
                                            setValue1("shippingToZip", zip);
                                          }
                                          setShipContactId(null);
                                          setSearchInput("");
                                          setDealerList([]);
                                          setIsPopoverVisibleDealer(false);
                                          // setSameAddress(true);
                                          // setShipSearchType("dealer_name");
                                          // setValue1("shippingSearchType", "dealer_name");
                                          setPaymentContactBased([
                                            "Affirm",
                                            "Cash",
                                            "Check",
                                            "Credit Card",
                                            "Crypto",
                                            "Paypal",
                                            "Scrap Gold",
                                            "Trade",
                                            "Venmo",
                                            "Wire",
                                            "Zelle",
                                          ]);
                                          setPaymentError(false);
                                          const dealerCountry = countryListData.find(
                                            (c) => c.name?.toLowerCase() === (dealer?.name || "").toLowerCase()
                                          );
                                          if (dealerCountry?.id) {
                                            getUserdetailsforsubscrption
                                              .getAllStateList(dealerCountry.id)
                                              .then((res) => {
                                                setStatesListData(res?.data?.data || []);
                                              });
                                          }
                                        }}
                                      >
                                        {listLabel && (
                                          <div style={{ fontSize: "13px", fontWeight: 400, color: "#000", fontFamily: "'Roboto', 'Helvetica', 'Arial', 'sans-serif'", letterSpacing: "0.00938em" }}>
                                            {listLabel}
                                          </div>
                                        )}
                                        {/* {detailLine && (
                                        <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
                                          {detailLine}
                                        </div>
                                      )} */}
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            {billSearchType === "dealer_name" &&
                              !dealerListLoading &&
                              searchInput.length >= 3 &&
                              dealerList.length === 0 && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    zIndex: 9999,
                                    background: "#fff",
                                    border: "1px solid #d9d9d9",
                                    borderRadius: "4px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                    padding: "10px 12px",
                                    width: "100%",
                                    fontSize: "13px",
                                    color: "#000",
                                  }}
                                >
                                  No dealer found
                                </div>
                              )}

                            {/* ── Contact Name search results (getInvoiceNewContactList) ── */}
                            {/* {billSearchType !== "dealer_name" && billSearchType !== "walk_in" && billCntcts && */}
                            {billSearchType !== "dealer_name" && billCntcts &&
                              billCntcts.length > 0 &&
                              searchInput.length > 0 ? (
                              <div
                                style={{
                                  marginLeft: "-70px",
                                  marginTop: "40px",
                                }}
                              >
                                <AntdPopover
                                  id={column.id}
                                  visible={isPopoverVisiblebill}
                                  content={
                                    <div
                                      style={{
                                        height:
                                          billCntcts.length < 4
                                            ? "auto"
                                            : "200px",
                                        overflow: "auto",
                                      }}
                                    >
                                      {billCntcts.map((el, index) => {
                                        return (
                                          <AccordionDetails key={index}>
                                            <Typography
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                handleContactSelection(
                                                  el,
                                                  "bill",
                                                )
                                              }
                                            >
                                              {handleContactAddress(el, "bill")}
                                            </Typography>
                                          </AccordionDetails>
                                        );
                                      })}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottomRight"
                                  // placement="bottomLeft"
                                  onVisibleChange={handleVisibleChange}
                                >
                                  <div
                                    style={{
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                </AntdPopover>
                              </div>
                              // ) : billSearchType !== "dealer_name" && billSearchType !== "walk_in" && billCntctSearchTxt?.length > 2 &&
                            ) : billSearchType !== "dealer_name" && billSearchType !== "walk_in" && billCntctSearchTxt?.length > 2 &&
                              billCntcts?.length == 0 &&
                              !fieldLoaderBill &&
                              (dataset == 0 || !dataset.length) ? (
                              <>
                                <AntdPopover
                                  id={column.id}
                                  visible={
                                    billCntctSearchTxt?.length > 2 &&
                                    billCntcts?.length == 0 &&
                                    (dataset == 0 || !dataset.length)
                                  }
                                  content={
                                    <div style={{ overflow: "auto" }}>
                                      <a
                                        className="dataItem"
                                        href="javascript:void(0)"
                                        onClick={() =>
                                          handleOpenCreateContactModal("bill")
                                        }
                                        style={{
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Click here to Create New Contact
                                      </a>
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottomRight"
                                  overlayStyle={{ marginTop: "5px" }}
                                >
                                  <div style={{ position: "relative" }} />
                                </AntdPopover>
                              </>
                            ) : null}
                          </div>
                          {/* {noBillData && (
                          <div className="dataResult">
                            <a className="dataItem">No data found</a>
                          </div>
                        )} */}
                        </>
                      )}
                      {column.type !== "text_search" && (
                        <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20">
                          {column.id !== "billingSearchType" && (
                            <>
                              {getValues1()[column.id] ? (
                                <InputLabel
                                  shrink={true}
                                  htmlFor="component-simple"
                                  style={{ color: "#818080" }}
                                >
                                  {column.label}
                                </InputLabel>
                              ) : (
                                <InputLabel
                                  htmlFor="component-simple"
                                  style={{ color: "#424242" }}
                                >
                                  {column.label}
                                </InputLabel>
                              )}
                            </>
                          )}
                          {column.type === "select" &&
                            column.id === "billingToState" && (
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={
                                  getValues1()[column.id]
                                    ? getValues1()[column.id]
                                    : ""
                                }
                                {...register1(column.id)}
                                onChange={(e) => {
                                  handleContactSearch(e, column.id, "bill");
                                  const val = e.target.value
                                    ? e.target.value.toString().trim()
                                    : e.target.value;
                                  setValue1(column.id, val);
                                }}
                                disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                              >
                                {statesListData &&
                                  statesListData.map((state) => (
                                    <MenuItem key={state.id} value={state.name}>
                                      {state.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            )}
                          {column.type === "select" &&
                            column.id === "billingToCountry" && (
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={
                                  getValues1()[column.id]
                                    ? getValues1()[column.id]
                                    : "United States"
                                }
                                {...register1(column.id)}
                                onChange={(e) => {
                                  onChangeCounry(e, column.id, "bill");
                                }}
                                disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                              >
                                {countryListData &&
                                  countryListData.map((country) => (
                                    <MenuItem
                                      key={country.id}
                                      value={country.name}
                                    >
                                      {country.name}
                                    </MenuItem>
                                  ))}
                              </Select>
                            )}
                          {column.type === "phone" && (
                            <>
                              <Grid container>
                                <Grid item xs={2}>
                                  <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    key={column.id}
                                    value={
                                      billingCountryCode
                                        ? billingCountryCode
                                        : ""
                                    }
                                    onChange={(e) => {
                                      setBillingCountryCode(e.target.value);
                                      if (isSameAddress) {
                                        setShippingCountryCode(e.target.value);
                                      }
                                    }}
                                    disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                                  >
                                    <MenuItem value=""></MenuItem>
                                    {UniqueCountryCode &&
                                      UniqueCountryCode.map((country) => (
                                        <MenuItem key={country} value={country}>
                                          {`${country}`}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={10}>
                                  <Input
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px",
                                      width: "100%",
                                      marginLeft: "10px",
                                    }}
                                    {...register1(column.id, {
                                      // required: "Please enter phone number",
                                      pattern: {
                                        value: /^(?!0+$)[0-9]{1,14}$/,
                                        message: "Invalid phone number",
                                      },
                                    })}
                                    placeholder="Enter your phone number"
                                    inputProps={{
                                      type: column.type,
                                      maxLength: 14,
                                      autoComplete: "off",
                                    }}
                                    onKeyPress={(event) => {
                                      if (!/^\d+$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      handleContactSearch(e, column.id, "bill");
                                    }}
                                    disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {column.type === "email" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                // required: "Please enter email",
                                pattern: {
                                  value: /\S+@\S+\.\S+/,
                                  message: "Invalid email address",
                                },
                              })}
                              inputProps={{
                                type: column.type,
                                autoComplete: "off",
                              }}
                              onChange={(e) => {
                                handleContactSearch(e, column.id, "bill");
                              }}
                              disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                            />
                          )}
                          {column.type === "number" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                // required: "Please enter zipcode",
                              })}
                              onKeyPress={(event) => {
                                if (!/^[A-Za-z\d\-_\s]$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                handleContactSearch(e, column.id, "bill");
                              }}
                              disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                            />
                          )}
                          {column.type === "search_type_dropdown" && (
                            <div style={{ marginTop: "10px", marginBottom: "8px", position: "relative" }}>
                              <Box
                                onClick={handleClick}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  gap: "4px",
                                  width: "fit-content",
                                  cursor: "pointer",
                                  marginBottom: "0px",
                                }}
                              >
                                <p style={{ fontSize: "13px", margin: 0 }}>
                                  {billSearchType === "dealer_name"
                                    ? "Include WatchOps Dealer"
                                    : billSearchType === "walk_in"
                                      ? "Include Walk-In / Temporary Customers"
                                      : "Include Business / Retail Contacts"}
                                </p>
                                {open ? (
                                  <KeyboardArrowUpIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </Box>

                              <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                              >
                                <MenuItem
                                  style={{ fontSize: "13px" }}
                                  onClick={() => {
                                    handleSearchTypeChange("other_option", "bill");
                                    handleClose();
                                    setContactValidationError("");
                                  }}
                                >
                                  Include Business / Retail Contacts
                                </MenuItem>

                                <MenuItem
                                  style={{ fontSize: "13px", color: "#646363" }}
                                  onClick={() => {
                                    handleSearchTypeChange("walk_in", "bill");
                                    handleClose();
                                    setContactValidationError("");
                                  }}
                                >
                                  Include Walk-In / Temporary Customers
                                </MenuItem>

                                <MenuItem
                                  style={{ fontSize: "13px", color: "#646363", display: "none" }}
                                  onClick={() => {
                                    handleSearchTypeChange("dealer_name", "bill");
                                    handleClose();
                                    setContactValidationError("");
                                  }}
                                >
                                  Include WatchOps Dealer
                                </MenuItem>
                              </Menu>
                              {contactValidationError && (
                                <div
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "12px",
                                    marginTop: "6px",
                                    lineHeight: "18px",
                                  }}
                                >
                                  {contactValidationError}
                                </div>
                              )}
                            </div>
                          )}
                          {column.type === "text" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                required: false,
                                // billSearchType === "walk_in" &&
                                // !isWalkInContactSelected &&
                                // column.id === "billingToBusinessName"
                                //   ? "Please enter Business Name"
                                //   : false,
                              })}
                              inputProps={{
                                type: column.type,
                                autoComplete: "off",
                              }}
                              onChange={(e) => {
                                setContactValidationError("");
                                handleContactSearch(e, column.id, "bill");
                                if (
                                  column.id === "billingToBusinessName" &&
                                  e.target.value.trim().length > 0
                                ) {
                                  clearErrors1("billingToBusinessName");
                                }
                              }}
                              disabled={billSearchType === "walk_in" ? isWalkInContactSelected : column.isDisabled}
                            />
                          )}
                          {errors1[column.id] &&
                            errors1[column.id]?.message && (
                              <span style={{ color: "red" }}>
                                {errors1[column.id].message}
                              </span>
                            )}
                        </FormControl>
                      )}
                    </>
                  ))}
                </div>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  position: "relative",
                  // ...(billSearchType === "dealer_name" && { pointerEvents: "none", opacity: 0.45 }),
                }}
              >
                <div>
                  <div>
                    <Typography className="color-232323">
                      <Grid container>
                        <Grid item xs={6} sm={6} md={6}>
                          <b>SHIP TO</b>
                        </Grid>
                        {/* <Grid item xs={6} sm={6} md={6}>
                            { !isShipTextInput ?
                                <Button variant="text" style={{ background: "gray", color: "#fff", fontSize:"12px", padding:"4px" }} onClick={()=>{changeTextMode('ship')}}>Click to Add Contact</Button>
                                :
                                <Button variant="text" style={{ background: "gray", color: "#fff", fontSize:"12px", padding:"4px" }} onClick={()=>{changeTextMode('ship')}}>Click to Search Contact</Button>
                        }
                        </Grid>   */}
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          justifyContent="flex-end"
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="checkedB1"
                                className="float-right"
                                onChange={handleSameaddressCheck}
                                checked={isSameAddress === true}
                              />
                            }
                            label="Same as bill address"
                          />
                        </Grid>
                      </Grid>
                    </Typography>
                  </div>
                  {shippingAddress.map((column, i) => (
                    <>
                      {column.type === "text_search" && (
                        <>
                          <div className="searchInputs">
                            <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20"
                              style={{ marginBottom: "-10px" }}
                            >
                              {shipCntctNm ? (
                                <InputLabel
                                  htmlFor="shipCntctNm"
                                  shrink={true}
                                  style={{ color: "#424242" }}
                                >
                                  {shipSearchType === "dealer_name" ? "Dealer Name" : "Contact Name"}
                                </InputLabel>
                              ) : null}
                              <AntdInput
                                ref={shipinputRef}
                                id="shipCntctNm"
                                type="text"
                                autoComplete="off"
                                className="invoice-contact-name-input"
                                value={shipCntctNm || ""}
                                placeholder={
                                  shipSearchType === "dealer_name"
                                    ? "Dealer Name"
                                    : "Contact Name"
                                }
                                disabled={
                                  isSameAddress ||
                                  isShippingFieldDisabled(column.isDisabled)
                                }
                                {...register1(column.id, {
                                  // required: column.required && billSearchType !== "dealer_name"
                                  // ? column.errMsg
                                  required: false,
                                })}
                                style={{
                                  marginBottom: "0px",
                                  marginTop: shipCntctNm ? "10px" : "0px",
                                  fontSize: "16px",
                                  paddingLeft: 0,
                                }}
                                onChange={(e) => {
                                  handleContactSearch(e, column.id, "ship");
                                }}
                                bordered={false}
                              />
                              {errors[column.id] && (
                                <span style={{ color: "red" }}>
                                  {column.errMsg}
                                </span>
                              )}
                              <Divider style={{ marginTop: "5px" }} />
                              <div className="contactSearchIcon">
                                <Grid container>
                                  <Grid item xs={6} sm={6} md={6}>
                                    {!isShipTextInput && (
                                      <>
                                        {!shipCntctNm ? (
                                          <SearchIcon
                                            style={{
                                              cursor: isSameAddress ? "default" : "pointer",
                                              opacity: isSameAddress ? 0.5 : 1,
                                            }}
                                          />
                                        ) : (
                                          <>
                                            {fieldLoaderShip ? (
                                              <CircularProgress
                                                style={{
                                                  width: "25px",
                                                  height: "25px",
                                                }}
                                              />
                                            ) : (
                                              !isSameAddress && (
                                                <CloseIcon
                                                  id="clearBtn"
                                                  onClick={() => {
                                                    clearCntctSearchInput("ship");
                                                  }}
                                                  style={{ cursor: "pointer" }}
                                                />
                                              )
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                </Grid>
                              </div>
                            </FormControl>
                            {!isOnetimeShippingAddress && shipCntcts &&
                              shipCntcts.length > 0 &&
                              searchInputship.length > 0 ? (
                              <div
                                style={{
                                  marginLeft: "-70px",
                                  marginTop: "40px",
                                }}
                              >
                                <AntdPopover
                                  id={column.id}
                                  visible={isPopoverVisibleship}
                                  content={
                                    <div
                                      style={{
                                        height:
                                          shipCntcts.length < 4
                                            ? "auto"
                                            : "200px",
                                        overflow: "auto",
                                      }}
                                    >
                                      {shipCntcts.map((el, index) => {
                                        return (
                                          <AccordionDetails key={index}>
                                            <Typography
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                handleContactSelection(
                                                  el,
                                                  "ship",
                                                )
                                              }
                                            >
                                              {handleContactAddress(el, "ship")}
                                            </Typography>
                                          </AccordionDetails>
                                        );
                                      })}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottomRight"
                                  onVisibleChange={handleVisibleChangeship}
                                >
                                  <div
                                    style={{
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                </AntdPopover>
                              </div>
                            ) : !isOnetimeShippingAddress && shipSearchType !== "walk_in" && searchInputship?.length > 2 &&
                              shipCntcts?.length == 0 &&
                              !fieldLoaderShip &&
                              (shippingdataset == 0 ||
                                !shippingdataset.length) ? (
                              <AntdPopover
                                id={column.id}
                                visible={
                                  !isOnetimeShippingAddress &&
                                  searchInputship?.length > 2 &&
                                  shipCntcts?.length == 0 &&
                                  (shippingdataset == 0 ||
                                    !shippingdataset.length)
                                }
                                content={
                                  <div style={{ overflow: "auto" }}>
                                    <a
                                      className="dataItem"
                                      onClick={() =>
                                        handleOpenCreateContactModal("ship")
                                      }
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Click here to Create New Contact
                                    </a>
                                  </div>
                                }
                                trigger="click"
                                placement="bottomRight"
                                overlayStyle={{ marginTop: "5px" }}
                              >
                                <div style={{ position: "relative" }} />
                              </AntdPopover>
                            ) : null}
                          </div>
                          {/* {noShipData && (
                          <div className="dataResult">
                            <a className="dataItem">No data found</a>
                          </div>
                        )} */}
                        </>
                      )}
                      {column.type !== "text_search" && (
                        <FormControl className="form-width-85 margin-t-b-20 margin-p-b-20">
                          {column.id !== "shippingSearchType" && (
                            <>
                              {getValues1()[column.id] ? (
                                <InputLabel
                                  shrink={true}
                                  htmlFor="component-simple"
                                  style={{ color: "#818080" }}
                                >
                                  {column.label}
                                </InputLabel>
                              ) : (
                                <InputLabel
                                  htmlFor="component-simple"
                                  style={{ color: "#424242" }}
                                >
                                  {column.label}
                                </InputLabel>
                              )}
                            </>
                          )}
                          {column.type === "select" && column.id === "shippingToCountry" && (
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              value={
                                getValues1()[column.id] ? getValues1()[column.id] : "United States"
                              }
                              {...register1(column.id)}
                              onChange={(e) => {
                                const val = e.target.value
                                  ? e.target.value.toString().trim()
                                  : e.target.value;
                                setValue1(column.id, val);
                                onChangeCounry(e, column.id);
                              }}
                              disabled={isShippingFieldDisabled(column.isDisabled)}
                            >
                              {countryListData &&
                                countryListData.map((country) => (
                                  <MenuItem key={country.id} value={country.name}>
                                    {country.name}
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                          {column.type === "select" && column.id === "shippingToState" && (
                            <Select
                              labelId="demo-simple-select-outlined-label-1"
                              id="demo-simple-select-outlined-1"
                              value={getValues1()[column.id] ? getValues1()[column.id] : ""}
                              {...register1(column.id)}
                              onChange={(e) => {
                                const val = e.target.value
                                  ? e.target.value.toString().trim()
                                  : e.target.value;
                                setValue1(column.id, val);
                              }}
                              disabled={isShippingFieldDisabled(column.isDisabled)}
                            >
                              {!isSameAddress &&
                                shippingStatesListData &&
                                shippingStatesListData.map((state) => (
                                  <MenuItem key={state.id} value={state.name}>
                                    {state.name}
                                  </MenuItem>
                                ))}
                              {isSameAddress &&
                                statesListData &&
                                statesListData.map((state) => (
                                  <MenuItem key={state.id} value={state.name}>
                                    {state.name}
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                          {column.type === "phone" && (
                            <>
                              <Grid container>
                                <Grid item xs={2}>
                                  <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    value={shippingCountryCode ? shippingCountryCode : ""}
                                    onChange={(e) => {
                                      setShippingCountryCode(e.target.value);
                                    }}
                                    disabled={isShippingFieldDisabled(column.isDisabled)}
                                  >
                                    <MenuItem value=""></MenuItem>
                                    {UniqueCountryCode &&
                                      UniqueCountryCode.map((country) => (
                                        <MenuItem key={country} value={country}>
                                          {`${country}`}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </Grid>
                                <Grid item xs={10}>
                                  <Input
                                    id="component-simple"
                                    style={{
                                      marginBottom: "10px",
                                      width: "100%",
                                      marginLeft: "10px",
                                    }}
                                    {...register1(column.id, {
                                      pattern: {
                                        value: /^(?!0+$)[0-9]{1,14}$/,
                                        message: "Invalid phone number",
                                      },
                                    })}
                                    placeholder="Enter your phone number"
                                    inputProps={{
                                      type: column.type,
                                      maxLength: 14,
                                      minlength: 1,
                                      autoComplete: "off",
                                    }}
                                    onKeyPress={(event) => {
                                      if (!/^\d+$/.test(event.key)) {
                                        event.preventDefault();
                                      }
                                    }}
                                    onChange={(e) => {
                                      handleContactSearch(e, column.id, "ship");
                                    }}
                                    disabled={isShippingFieldDisabled(column.isDisabled)}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          )}
                          {column.type === "email" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                // required: "Please enter email",
                                pattern: {
                                  value: /\S+@\S+\.\S+/,
                                  message: "Invalid email address",
                                },
                              })}
                              inputProps={{
                                type: column.type,
                                autoComplete: "off",
                              }}
                              onChange={(e) => {
                                handleContactSearch(e, column.id, "ship");
                              }}
                              disabled={isShippingFieldDisabled(column.isDisabled)}
                            />
                          )}
                          {column.type === "number" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                // required: "Please enter zipcode",
                              })}
                              onKeyPress={(event) => {
                                if (!/^[A-Za-z\d\-_\s]$/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                handleContactSearch(e, column.id, "ship");
                              }}
                              disabled={isShippingFieldDisabled(column.isDisabled)}
                            />
                          )}
                          {column.type === "search_type_dropdown" && (
                            <div style={{ marginTop: "10px", marginBottom: "8px" }}>
                              <Box
                                onClick={handleShipClick}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  gap: "4px",
                                  width: "fit-content",
                                  marginBottom: "0px",
                                }}
                              >
                                <p style={{ fontSize: "13px", margin: 0 }}>
                                  {isOnetimeShippingAddress
                                    ? "One-time Shipping Address"
                                    : shipSearchType === "dealer_name"
                                    ? "Include WatchOps Dealer"
                                    : shipSearchType === "walk_in"
                                      ? "Include Walk-In / Temporary Customers"
                                      : "Include Business / Retail Contacts"}
                                </p>
                                {shipOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </Box>

                              <Menu anchorEl={shipAnchorEl} open={shipOpen} onClose={handleShipClose}>
                                <MenuItem
                                  style={{ fontSize: "13px" }}
                                  onClick={() => {
                                    setSameAddress(false);
                                    setIsOnetimeShippingAddress(false);
                                    handleSearchTypeChange("other_option", "ship");
                                    handleShipClose();
                                  }}
                                >
                                  Include Business / Retail Contacts
                                </MenuItem>

                                <MenuItem
                                  style={{ fontSize: "13px", color: "#646363" }}
                                  onClick={() => {
                                    setSameAddress(false);
                                    setIsOnetimeShippingAddress(false);
                                    handleSearchTypeChange("walk_in", "ship");
                                    handleShipClose();
                                  }}
                                >
                                  Include Walk-In / Temporary Customers
                                </MenuItem>

                                <MenuItem
                                  style={{ fontSize: "13px", color: "#646363" }}
                                  onClick={() => {
                                    setSameAddress(false);
                                    setIsOnetimeShippingAddress(true);
                                    setShipContactId(null);
                                    setIsShipWalkInContactSelected(false);
                                    setShipCntctSearchTxt(null);
                                    setShipCntcts([]);
                                    setIsPopoverVisibleship(false);
                                    setFieldLoaderShip(false);
                                    setshippingdataset([]);
                                    handleShipClose();
                                  }}
                                >
                                  One-time Shipping Address
                                </MenuItem>
                              </Menu>
                              {shipContactValidationError && (
                                <div
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "12px",
                                    marginTop: "6px",
                                    lineHeight: "18px",
                                  }}
                                >
                                  {shipContactValidationError}
                                </div>
                              )}
                            </div>
                          )}
                          {column.type === "text" && (
                            <Input
                              id="component-simple"
                              key={column.id}
                              style={{ marginBottom: "10px" }}
                              {...register1(column.id, {
                                required: false,
                                // !isSameAddress &&
                                // shipSearchType === "walk_in" &&
                                // !isShipWalkInContactSelected &&
                                // column.id === "shippingToBusinessName"
                                //   ? "Please enter Business Name"
                                //   : false,
                              })}
                              inputProps={{
                                type: column.type,
                                autoComplete: "off",
                              }}
                              onChange={(e) => {
                                handleContactSearch(e, column.id, "ship");
                                if (
                                  column.id === "shippingToBusinessName" &&
                                  e.target.value.trim().length > 0
                                ) {
                                  clearErrors1("shippingToBusinessName");
                                }
                              }}
                              disabled={isShippingFieldDisabled(column.isDisabled)}
                            />
                          )}
                          {errors1[column.id] && errors1[column.id].message && !isSameAddress && (
                            <span style={{ color: "red" }}>{errors1[column.id].message}</span>
                          )}
                        </FormControl>
                      )}
                    </>
                  ))}
                </div>
              </Grid>
            </Grid>
            {rows.length > 0 ? (
              <Typography variant="h6">Details</Typography>
            ) : null}
            <TableContainer
              sx={{ maxHeight: 440, marginTop: "20px", marginBottom: "20px" }}
            >
              <Table aria-label="sticky table">
                {/* <TableHead>
                  <TableRow>
                    {isConvertToSale && <StyledTableCell></StyledTableCell>}
                    {invoiceObj
                      .filter(
                        (item) =>
                          item.id !== "currency" && item.id !== "modelAndSerial"
                      )
                      .map((column) => (
                        <StyledTableCell
                          key={column.id}
                          align={column.align}
                          style={{ minWidth: column.minWidth }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                  </TableRow>
                </TableHead> */}
                <TableBody>
                  {rows.length > 0 && (
                    <>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          SHIPPING
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            type="text"
                            className="form-width-100"
                            {...register1("shippingPrice")}
                            placeholder="$0.00"
                            style={{ height: "30px" }}
                            value={shipping}
                            onChange={(e) =>
                              setShipping(
                                e.target.value.replace(/[^0-9\.]/g, ""),
                              )
                            }
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          DISCOUNT
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            type="text"
                            className="form-width-100"
                            {...register1("discount")}
                            placeholder="$0.00"
                            style={{ height: "30px" }}
                            value={discount}
                            onChange={(e) => {
                              const cleaned = e.target.value.replace(
                                /[^0-9\.]/g,
                                "",
                              );
                              setDiscount(cleaned);
                              setValue1("discount", cleaned); // optional: sync with react-hook-form
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          TAX
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            {...register1("tax")}
                            placeholder="$0.00"
                            style={{ height: "30px" }}
                            value={tax ?? ""}
                            disabled={
                              !(
                                userDetails?.roleId === 2 ||
                                userDetails?.roleId === 3 ||
                                userDetails?.roleId === 6
                              ) &&
                              isSalesTaxIncluded &&
                              classification_type !== "business_client"
                            }
                            onFocus={(e) => {
                              if (e.target.value) {
                                e.target.select();
                              }
                            }}
                            onChange={(e) => {
                              const cleaned = e.target.value.replace(
                                /[^0-9\.]/g,
                                "",
                              );
                              setTax(cleaned || null);
                              setValue1("tax", cleaned);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          FEES
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            {...register1("fees")}
                            placeholder="$0.00"
                            style={{ height: "30px" }}
                            value={fees}
                            onChange={(e) =>
                              setFees(e.target.value.replace(/[^0-9\.]/g, ""))
                            }
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          DEPOSIT
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            type="text"
                            className="form-width-100"
                            {...register1("deposit", {
                              validate: (value) =>
                                validateDeposit(
                                  value,
                                  rows,
                                  getValues1,
                                  isConvertToSale,
                                  paymentmethod,
                                ),
                            })}
                            placeholder="$0.00"
                            style={{ height: "30px" }}
                            value={deposit}
                            // onChange={(e) =>
                            //   setDeposit(e.target.value.replace(/[^0-9\.]/g, ""))
                            // }
                            onChange={onchangeDeposit}
                          />
                          {errors1.deposit && (
                            <FormHelperText className="error-o">
                              {errors1?.deposit?.message}
                            </FormHelperText>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          PAYMENT METHOD
                        </TableCell>
                        <TableCell colspan={3}>
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            fullWidth
                            {...register1("payment_method")}
                            onChange={(e) => handlePaymentMethod(e)}
                            value={paymentmethod}
                            inputProps={{
                              autoComplete: "off",
                            }}
                          >
                            {paymentContactBased?.length > 0 &&
                              paymentContactBased
                                .sort((a, b) => a.localeCompare(b))
                                .map((value, index) => (
                                  <MenuItem key={index} value={value}>
                                    {value}
                                  </MenuItem>
                                ))}
                          </Select>
                          {paymentError && (
                            <FormHelperText className="error-o">
                              {paymentContactBased.length === 0
                                ? "No Preferred Payment Method has been set for the selected contact"
                                : "Please select Payment Method"}
                            </FormHelperText>
                          )}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        {paymentmethod === "Trade" && (
                          <TableCell
                            colSpan={4}
                            style={{ textAlign: "left", borderBottom: 0 }}
                          >
                            {/* Trade Inventory */}
                            TRADE INVENTORY
                          </TableCell>
                        )}
                        {paymentmethod === "Trade" && (
                          <TableCell colSpan={3} style={{ borderBottom: 0 }}>
                            <FormControlLabel
                              onClick={() => setInventoryError("")}
                              control={
                                <Checkbox
                                  checked={tradeInventory}
                                  onChange={onChangeOfCheckBoxInventory}
                                />
                              }
                              label={
                                <span classNme="font-14">
                                  {tradeInventory
                                    ? "Create New Trade Inventory"
                                    : "Use an Existing Inventory for Trade"}
                                </span>
                              }
                            />
                            {inventoryError && (
                              <FormHelperText className="error-o">
                                {inventoryError}
                              </FormHelperText>
                            )}
                          </TableCell>
                        )}
                      </TableRow>
                      {paymentmethod === "Trade" && !tradeInventory && (
                        <TableRow>
                          <TableCell colSpan={4} style={{ textAlign: "left" }}>
                            {" "}
                          </TableCell>
                          <TableCell colSpan={3} style={{ paddingTop: 0 }}>
                            <div className="searchInputs">
                              <FormControl className="form-width-100 space-marign-bottom-10">
                                <Controller
                                  name="tradeModelAndSerial"
                                  control={control}
                                  // rules={{ required: !currentItem }} //TODO: need revisit this
                                  render={({ field, fieldState }) => (
                                    <Autocomplete
                                      // value={tradeInventory ? tradeAutoValue : null}
                                      // inputValue={tradeInventory ? searchText : ""}
                                      value={tradeAutoValue}
                                      inputValue={searchText}
                                      onInputChange={(event, newInputValue) => {
                                        setSearchText(newInputValue);
                                      }}
                                      onChange={(event, newValue) => {
                                        // if (!tradeInventory) return;
                                        // try {
                                        //   field.onChange(newValue);
                                        // } catch (e) {
                                        // }
                                        field.onChange(newValue);
                                        if (newValue) {
                                          setInventoryError("");
                                          setTradeAutoValue(newValue);
                                          handleTradeInventorySelect(newValue);
                                          setSearchText("");
                                          setWatchType(newValue?.type ?? "standard_watch");
                                          if (newValue?.inventoryid) {
                                            setSelectedInlineInventoryIds(
                                              (prev) =>
                                                prev &&
                                                  prev.includes(
                                                    newValue.inventoryid,
                                                  )
                                                  ? prev
                                                  : [
                                                    ...(prev || []),
                                                    newValue.inventoryid,
                                                  ],
                                            );
                                          }
                                        } else {
                                          const prevInv =
                                            field.value &&
                                            field.value.inventoryid;
                                          if (prevInv) {
                                            setSelectedInlineInventoryIds(
                                              (prev) =>
                                                (prev || []).filter(
                                                  (id) => id !== prevInv,
                                                ),
                                            );
                                          }
                                          // setModel(null);
                                          // setSerial(null);
                                          // setInventoryId(null);
                                          // setProductId(null);
                                          // setDesc(null);
                                          // setImage(null);
                                          // setQuantity(1);
                                          setTradeAutoValue(null);
                                          setTradeInventoryId(null);
                                          setTradeModel(null);
                                          setTradeSerialNumber(null);
                                          setTradeModelName(null);
                                          setTradeModelNumber(null);
                                          setTradeInventoryPrice(null);
                                          setTradeMiscCategory(null);
                                        }
                                      }}
                                      openOnFocus={false}
                                      options={invoiceListData.filter((opt) => {
                                        const invType =
                                          opt.inventorytype ??
                                          opt.inventory_type ??
                                          null;
                                        return invType !== 4 && invType !== "4";
                                      })}
                                      getOptionDisabled={(option) =>
                                        rows.some(
                                          (row) => {
                                            const rowInvId = row.inventoryId || row.inventoryid || row.id;
                                            return rowInvId === option.inventoryid;
                                          }
                                        )
                                      }
                                      getOptionLabel={(option) =>
                                        `${option.model} | ${option.serialno || "---"} | ${option.inventoryid}`
                                      }
                                      filterOptions={(options, state) => {
                                        const input =
                                          state.inputValue?.toLowerCase() || "";

                                        return options.filter(
                                          (option) =>
                                            option.model
                                              ?.toLowerCase()
                                              .includes(input) ||
                                            option.serialno
                                              ?.toLowerCase()
                                              .includes(input) ||
                                            String(option.inventoryid).includes(
                                              input,
                                            ),
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="standard"
                                          label="Search Model | Serial No | Inventory ID"
                                          placeholder="Search Model | Serial No | Inventory ID"
                                          InputProps={{
                                            ...params.InputProps,
                                            // readOnly:  !!currentItem,
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                />
                              </FormControl>
                            </div>
                          </TableCell>
                        </TableRow>
                      )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        TradeInventoryId && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              TYPE
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="TYPE"
                                style={{ height: "30px" }}
                                value={
                                  tradeWatchType
                                    ? tradeWatchType === "misc_watch"
                                      ? "Misc Watch"
                                      : tradeWatchType === "misc_product"
                                        ? "Misc Product"
                                        : "Standard Watch"
                                    : tradeWatchType === "misc_watch"
                                      ? "Misc Watch"
                                      : tradeWatchType === "misc_product"
                                        ? "Misc Product"
                                        : "Standard Watch"
                                }
                                readOnly={true}
                                onChange={(e) => setType(e.target.value)}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        tradeWatchType === null &&
                        TradeInventoryId && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              MODEL
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL"
                                style={{ height: "30px" }}
                                value={tradeModel}
                                readOnly={true}
                                onChange={(e) => setTradeModel(e.target.value)}
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        TradeInventoryId &&
                        tradeWatchType === "misc_product" && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              MISC CATEGORY
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MISC CATEGORY"
                                style={{ height: "30px" }}
                                value={tradeMiscCategory}
                                readOnly={true}
                                onChange={(e) =>
                                  setTradeMiscCategory(e.target.value)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        TradeInventoryId &&
                        (tradeWatchType === "misc_watch" ||
                          tradeWatchType === "misc_product") && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              MODEL NAME
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL NAME"
                                style={{ height: "30px" }}
                                value={tradeModelName}
                                readOnly={true}
                                onChange={(e) =>
                                  setTradeModelName(e.target.value)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        TradeInventoryId && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              SERIAL NUMBER
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="SERIAL NUMBER"
                                style={{ height: "30px" }}
                                value={tradeSerialNumber}
                                readOnly={true}
                                onChange={(e) =>
                                  setTradeSerialNumber(e.target.value)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" &&
                        !tradeInventory &&
                        tradeWatchType === "misc_product" &&
                        TradeInventoryId && (
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              MODEL NUMBER
                            </TableCell>
                            <TableCell colspan={3}>
                              <input
                                className="form-width-100"
                                type="text"
                                placeholder="MODEL NUMBER"
                                style={{ height: "30px" }}
                                value={tradeModelNumber}
                                readOnly={true}
                                onChange={(e) =>
                                  setTradeModelNumber(e.target.value)
                                }
                              />
                            </TableCell>
                          </TableRow>
                        )}
                      {paymentmethod === "Trade" && tradeInventory && (
                        <>
                          <TableRow>
                            <TableCell
                              colspan={4}
                              style={{ textAlign: "left" }}
                            >
                              TYPE
                            </TableCell>
                            <TableCell colspan={3}>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                fullWidth
                                disabled={tradeInventory && !!inventoryid}
                                {...register1("watchType", {
                                  required:
                                    paymentmethod === "Trade"
                                      ? "Please select Type"
                                      : false,
                                })}
                                value={watchType}
                                onChange={(e) => {
                                  setWatchType(e.target.value);
                                  handleNonTrade();
                                }}
                                inputProps={{
                                  autoComplete: "off",
                                }}
                              >
                                <MenuItem value="standard_watch">
                                  Standard Watch
                                </MenuItem>
                                <MenuItem value="misc_watch">
                                  Misc Watch
                                </MenuItem>
                                <MenuItem value="misc_product">
                                  Misc Product
                                </MenuItem>
                              </Select>
                              {errors1?.watchType && (
                                <FormHelperText className="error-o">
                                  {errors1?.watchType?.message}
                                </FormHelperText>
                              )}
                            </TableCell>
                          </TableRow>

                          {paymentmethod === "Trade" &&
                            watchType === "standard_watch" &&
                            tradeInventory && (
                              <TableRow>
                                <TableCell
                                  colspan={4}
                                  style={{ textAlign: "left" }}
                                >
                                  MODEL
                                </TableCell>
                                <TableCell colspan={3}>
                                  <Input
                                    id="model"
                                    inputProps={{ type: "text" }}
                                    autoComplete={"off"}
                                    value={tradeModel}
                                    {...register1("tradeModel", {
                                      required:
                                        paymentmethod === "Trade" &&
                                          watchType === "standard_watch"
                                          ? "Please select Model"
                                          : false,
                                      onChange: (e) => {
                                        handleTradeSearch(e, "tradeModel");
                                      },
                                    })}
                                    variant="outline"
                                    placeholder="Model"
                                    className="form-width-100 form-control searchoption boxwidth"
                                    style={{ margin: 0, padding: 0 }}
                                    endAdornment={
                                      searchTradeObj?.searchVal?.length > 0 ? (
                                        <>
                                          <InputAdornment position="end">
                                            {searchLoading ? (
                                              <CircularProgress
                                                style={{
                                                  width: 25,
                                                  height: 25,
                                                }}
                                              />
                                            ) : (
                                              <IconButton
                                                onClick={() => {
                                                  setPropsModelList([]);
                                                  setTradeModel("");
                                                  setSearchLoading(false);
                                                  setSearchTradeObj(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      searchVal: "",
                                                      searchText: "",
                                                      from: "trade",
                                                    }),
                                                  );
                                                }}
                                                color="primary"
                                              >
                                                <ClearIcon />
                                              </IconButton>
                                            )}
                                          </InputAdornment>
                                        </>
                                      ) : null
                                    }
                                  />
                                  {errors1?.tradeModel && (
                                    <FormHelperText className="error-o">
                                      {errors1?.tradeModel?.message}
                                    </FormHelperText>
                                  )}
                                  {searchLoading ? null : searchTradeObj
                                    ?.searchVal?.length > 0 &&
                                    searchTradeObj?.column === "tradeModel" &&
                                    propsModelList.length > 0 ? (
                                    <List
                                      className="form-width-100 searchlist MuiPaper-elevation1 inventrysearch"
                                      style={{ listStyle: "none" }}
                                    >
                                      {propsModelList.map((item, idx) => (
                                        <div>
                                          <ListItem
                                            key={idx}
                                            onClick={() =>
                                              handleTradeSelection(
                                                item,
                                                "model",
                                              )
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            <ListItemIcon>
                                              <IconButton color="primary">
                                                <img
                                                  width="45"
                                                  src={
                                                    item.imagepaths?.images
                                                      ?.toString()
                                                      .split(",")[0]
                                                  }
                                                  alt="Product"
                                                />
                                              </IconButton>
                                            </ListItemIcon>
                                            <ListItemText
                                              primary={
                                                item.brandname +
                                                " " +
                                                item.model
                                              }
                                              secondary={item.family}
                                              style={{
                                                marginTop: "25px",
                                                marginLeft: "80px",
                                              }}
                                            />
                                          </ListItem>
                                          <Divider
                                            variant="inset"
                                            component="li"
                                          />
                                        </div>
                                      ))}
                                    </List>
                                  ) : null}
                                </TableCell>
                              </TableRow>
                            )}

                          {paymentmethod === "Trade" &&
                            watchType === "misc_product" && (
                              <TableRow>
                                <TableCell
                                  colspan={4}
                                  style={{ textAlign: "left" }}
                                >
                                  MISC CATEGORY
                                </TableCell>
                                <TableCell colspan={3}>
                                  <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    fullWidth
                                    {...register1("tradeMiscCategory", {
                                      required:
                                        paymentmethod === "Trade" &&
                                          watchType === "misc_product"
                                          ? "Please select Misc Category"
                                          : false,
                                    })}
                                    value={tradeMiscCategory}
                                    onChange={(e) =>
                                      setTradeMiscCategory(e.target.value)
                                    }
                                    inputProps={{
                                      autoComplete: "off",
                                    }}
                                  >
                                    <MenuItem value="watch related accessories">
                                      Watch Related Accessories
                                    </MenuItem>
                                    <MenuItem value="apparel">Apparel</MenuItem>
                                    <MenuItem value="watch parts">
                                      Watch Parts
                                    </MenuItem>
                                    <MenuItem value="jewelry">Jewelry</MenuItem>
                                    <MenuItem value="stones">Stones</MenuItem>
                                    <MenuItem value="hand bags">
                                      Hand Bags
                                    </MenuItem>
                                    <MenuItem value="wallets">Wallets</MenuItem>
                                    <MenuItem value="bag related accessories">
                                      Bag Related Accessories
                                    </MenuItem>
                                    <MenuItem value="service watches">
                                      Service Watches
                                    </MenuItem>
                                    <MenuItem value="others">Others</MenuItem>
                                  </Select>
                                  {errors1?.tradeMiscCategory && (
                                    <FormHelperText className="error-o">
                                      {errors1?.tradeMiscCategory?.message}
                                    </FormHelperText>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                          {paymentmethod === "Trade" &&
                            (watchType === "misc_watch" ||
                              watchType === "misc_product") && (
                              <TableRow>
                                <TableCell
                                  colspan={4}
                                  style={{ textAlign: "left" }}
                                >
                                  MODEL NAME
                                </TableCell>
                                <TableCell colspan={3}>
                                  <input
                                    className="form-width-100"
                                    type="text"
                                    {...register1("tradeModelName", {
                                      required:
                                        paymentmethod === "Trade" &&
                                          watchType === "misc_product"
                                          ? "Please enter Model Name"
                                          : false,
                                    })}
                                    placeholder="Model Name"
                                    style={{ height: "30px" }}
                                    value={tradeModelName}
                                    onChange={(e) =>
                                      setTradeModelName(e.target.value)
                                    }
                                  />
                                  {errors1?.tradeModelName && (
                                    <FormHelperText className="error-o">
                                      {errors1?.tradeModelName?.message}
                                    </FormHelperText>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                          {paymentmethod === "Trade" &&
                            tradeInventory &&
                            (watchType === "standard_watch" ||
                              watchType === "misc_watch" ||
                              watchType === "misc_product") &&
                            tradeInventory && (
                              <TableRow>
                                <TableCell
                                  colspan={4}
                                  style={{ textAlign: "left" }}
                                >
                                  SERIAL NUMBER
                                </TableCell>
                                <TableCell colspan={3}>
                                  <input
                                    className="form-width-100"
                                    type="text"
                                    {...register1("tradeSerialNumber", {
                                      required:
                                        paymentmethod === "Trade" &&
                                          (watchType === "standard_watch" ||
                                            watchType === "misc_watch")
                                          ? "Please Enter Serial Number"
                                          : false,
                                    })}
                                    placeholder="Serial Number"
                                    style={{ height: "30px" }}
                                    value={tradeSerialNumber}
                                    onChange={(e) =>
                                      setTradeSerialNumber(e.target.value)
                                    }
                                  />
                                  {errors1?.tradeSerialNumber && (
                                    <FormHelperText className="error-o">
                                      {errors1?.tradeSerialNumber?.message}
                                    </FormHelperText>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                          {paymentmethod === "Trade" &&
                            watchType === "misc_product" && (
                              <TableRow>
                                <TableCell
                                  colspan={4}
                                  style={{ textAlign: "left" }}
                                >
                                  MODEL NUMBER
                                </TableCell>
                                <TableCell colspan={3}>
                                  <input
                                    className="form-width-100"
                                    type="text"
                                    displayEmpty
                                    {...register1(
                                      "tradeModelNumber",
                                      //    ,{
                                      //   required: (paymentmethod === "Trade" && watchType === "misc_product")
                                      //     ? "Please enter Model Number" : false,
                                      // }
                                    )}
                                    placeholder="Model Number"
                                    style={{ height: "30px" }}
                                    value={tradeModelNumber}
                                    onChange={(e) =>
                                      setTradeModelNumber(e.target.value)
                                    }
                                  />
                                  {errors1?.tradeModelNumber && (
                                    <FormHelperText className="error-o">
                                      {errors1?.tradeModelNumber?.message}
                                    </FormHelperText>
                                  )}
                                </TableCell>
                              </TableRow>
                            )}
                        </>
                      )}
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          PAYMENT DETAILS
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            {...register1("paymentDetails")}
                            placeholder="Payment Details"
                            style={{ height: "30px" }}
                            value={paymentdetails}
                            onChange={(e) => setPaymentDetails(e.target.value)}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          PAYMENT TERM
                        </TableCell>
                        <TableCell colspan={3}>
                          <Select
                            {...register1("terms")}
                            value={watch1("terms")}
                            // defaultValue="Immediate"
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            fullWidth
                          >
                            <MenuItem value="Immediate">Immediate</MenuItem>
                            <MenuItem value="Net 7 Days">Net 7 Days</MenuItem>
                            <MenuItem value="Net 14 Days">Net 14 Days</MenuItem>
                            <MenuItem value="Net 21 Days">Net 21 Days</MenuItem>
                            <MenuItem value="Net 30 Days">Net 30 Days</MenuItem>
                            <MenuItem value="Net 60 Days">Net 60 Days</MenuItem>
                            <MenuItem value="Net 90 Days">Net 90 Days</MenuItem>
                          </Select>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          SHIPPING DATE
                        </TableCell>
                        <TableCell colspan={3}>
                          <div>
                            <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  // className="color-BCBCBC"
                                  margin="normal"
                                  id="date-picker-dialog"
                                  format="MM/dd/yyyy"
                                  // disableFuture={true}
                                  value={shippingDate}
                                  onChange={(date, e) => {
                                    setShippingDate(e);
                                  }}
                                  isClearable
                                  KeyboardButtonProps={{
                                    "aria-label": "change date",
                                  }}
                                  placeholder="MM/DD/YYYY"
                                  onPaste={(event) => event.preventDefault()}
                                  helperText={""}
                                />
                              </MuiPickersUtilsProvider>
                            </FormControl>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          SOLD DATE
                        </TableCell>
                        <TableCell colspan={3}>
                          <div>
                            <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  // className="color-BCBCBC"
                                  margin="normal"
                                  id="date-picker-dialog"
                                  format="MM/dd/yyyy"
                                  //disableFuture={true}
                                  value={soldDate}
                                  onChange={(date) => {
                                    setSoldDate(date || new Date());
                                  }}
                                  isClearable
                                  KeyboardButtonProps={{
                                    "aria-label": "change date",
                                  }}
                                  placeholder="MM/DD/YYYY"
                                  onPaste={(event) => event.preventDefault()}
                                  helperText={""}
                                />
                              </MuiPickersUtilsProvider>
                            </FormControl>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          SHIPPING METHOD
                        </TableCell>
                        <TableCell colspan={3}>
                          <Select
                            {...register1("shippingMethod")}
                            value={watch1("shippingMethod")}
                            // onChange={(e) => setShippingMethod(e.target.value)}
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            fullWidth
                          >
                            <MenuItem value="USPS">USPS</MenuItem>
                            <MenuItem value="Fedex">Fedex</MenuItem>
                            <MenuItem value="UPS">UPS</MenuItem>
                            <MenuItem value="Ferrari">Ferrari</MenuItem>
                            <MenuItem value="Local Pickup">
                              Local Pickup
                            </MenuItem>
                          </Select>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          TRACKING NUMBER
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            {...register1("trackingNumber")}
                            placeholder="Tracking Number"
                            style={{ height: "30px" }}
                            value={trackingNumber}
                            onChange={(e) => setTrackingNumber(e.target.value)}
                            maxLength={150}
                          />
                        </TableCell>
                      </TableRow>
                      {/* <TableRow>
                      <TableCell colspan={4} style={{ textAlign: "right" }}>
                        TAX ID
                      </TableCell>
                      <TableCell colspan={3}>
                        <input
                          className="form-width-100"
                          type="text"
                          {...register1("taxId")}
                          placeholder="Tax Id"
                          style={{ height: "30px" }}
                          value={Taxid}
                          onChange={(e) => {
                            setTaxid(e.target.value); 
                     
                          }}
                        />
                        {Number(tax) > 0 && ( 
                                  <FormHelperText className="error-o">Please provide Tax Id</FormHelperText>
                                   )} 
                      </TableCell>
                      
                    </TableRow> */}
                      <TableRow>
                        <TableCell colspan={4} style={{ textAlign: "left" }}>
                          NOTES
                        </TableCell>
                        <TableCell colspan={3}>
                          <input
                            className="form-width-100"
                            type="text"
                            {...register1("notes")}
                            placeholder="Notes"
                            style={{ height: "30px" }}
                            value={notes}
                            onChange={(e) => {
                              setNotes(e.target.value);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          colspan={12}
                          style={{ textAlign: "left", gap: "30px" }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="checkedB1"
                                className="float-right"
                                checked={wireDetails}
                                value={wireDetails}
                                onChange={onChangeOfCheckBox}
                              />
                            }
                            label={
                              <p style={{ fontSize: "14px" }}>
                                &nbsp;Include Wire Details
                              </p>
                            }
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="checkedB1"
                                className="float-right"
                                checked={zelleDetails}
                                value={zelleDetails}
                                onChange={onChangeOfCheckBoxZelle}
                              />
                            }
                            label={
                              <p style={{ fontSize: "14px" }}>
                                &nbsp;Include Zelle Details
                              </p>
                            }
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="checkedB1"
                                className="float-right"
                                checked={venmoDetails}
                                value={venmoDetails}
                                onChange={onChangeOfCheckBoxVenmo}
                              />
                            }
                            label={
                              <p style={{ fontSize: "14px" }}>
                                &nbsp;Include Venmo Details
                              </p>
                            }
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                name="checkedB1"
                                className="float-right"
                                checked={shippingDetails}
                                value={shippingDetails}
                                onChange={onchangeshipping}
                              />
                            }
                            label={
                              <p style={{ fontSize: "14px" }}>
                                &nbsp;Include Shipping Details
                              </p>
                            }
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {isSubmitInvoice && (
              <div class="d-spinner">
                <SpinnerRoundFilled
                  size={51}
                  thickness={125}
                  speed={80}
                  color="rgba(57, 107, 172, 1)"
                  className="spp"
                  enabled={isSubmitInvoice}
                />
              </div>
            )}
            {!isSubmitInvoice && rows.length > 0 && (
              <>
                {walkInValidationError && (
                  <Grid item xs={12}>
                    <span
                      style={{
                        color: "red",
                        fontSize: "13px",
                        marginBottom: "8px",
                        display: "block",
                        textAlign: "right",
                      }}
                    >
                      {walkInValidationError}
                    </span>
                  </Grid>
                )}
                {depositError && (
                  <Grid item xs={12}>
                    <span
                      style={{
                        color: "red",
                        fontSize: "13px",
                        marginLeft: "250px",
                        marginBottom: "8px",
                        display: "inline-block",
                      }}
                    >
                      {depositError}
                    </span>
                  </Grid>
                )}
                {depositAmountError && (
                  <Grid item xs={12}>
                    <span
                      style={{
                        color: "red",
                        fontSize: "13px",
                        marginLeft: "600px",
                        marginBottom: "8px",
                        display: "inline-block",
                      }}
                    >
                      {depositAmountError}
                    </span>
                  </Grid>
                )}
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    type="submit"
                    variant="text"
                    style={{
                      background: "#000",
                      color: "#fff",
                      float: "right",
                      marginTop: 20,
                      marginBottom: 20,
                    }}
                    disabled={
                      isConvertToSale &&
                      rows?.filter((row) => row.checked)?.length == 0
                    }
                  >
                    Create Invoice
                  </Button>
                </Grid>
                {isConvertToSale && (
                  <Grid
                    container
                    item
                    xs={12}
                    sm={12}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: 20,
                    }}
                  >
                    <Typography variant="inherit" className="color-454545">
                      <i>
                        Note: Clicking the "Create Invoice" button will generate
                        an invoice for the selected{" "}
                        {rows?.filter((row) => row.checked)?.length || 0}{" "}
                        item(s).
                      </i>
                    </Typography>
                  </Grid>
                )}
              </>
            )}
          </form>
        )}
        <AntdModal
          open={openModal}
          footer={null}
          onCancel={handleCloseModal}
        // onClose={handleCloseModal}
        // aria-labelledby="modal-modal-title"
        >
          <Box>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {currentItem ? "Edit Item" : "Add Item"}
            </Typography>
            <form key={3} onSubmit={handleSubmit(onSubmit)}>
              {invoiceObj.map((column) => {
                return (
                  <>
                    {column.id === "modelAndSerial" && (
                      <>
                        <div className="searchInputs">
                          <FormControl className="form-width-100 space-marign-bottom-10">
                            <Controller
                              name={column.id}
                              control={control}
                              rules={{
                                required:
                                  currentItem &&
                                    Object.keys(currentItem).length > 0
                                    ? false
                                    : true,
                              }}
                              render={({
                                field: { onChange, value },
                                fieldState: { error },
                              }) => (
                                <Autocomplete
                                  disabled={currentItem}
                                  options={invoiceListData?.filter(
                                    (item) => item.sold === 0,
                                  )}
                                  getOptionDisabled={(option) => {
                                    const inRows = rows.some(
                                      (item) => {
                                        const itemInvId = item.inventoryId || item.inventoryid || item.id;
                                        return itemInvId === option.inventoryid;
                                      }
                                    );
                                    const inInline =
                                      selectedInlineInventoryIds &&
                                      selectedInlineInventoryIds.includes(
                                        option.inventoryid,
                                      );
                                    return inRows || inInline;
                                  }}
                                  getOptionLabel={(option) => {
                                    const model = option?.model || "";
                                    const productTitle =
                                      option?.technical_details
                                        ?.product_title || "";
                                    const productName =
                                      option?.technical_details?.product_name ||
                                      "";
                                    const productLabel =
                                      model ||
                                      productTitle ||
                                      productName ||
                                      "---";
                                    const serialNo =
                                      option?.serialno ||
                                      option?.technical_details?.model_number ||
                                      "---";
                                    const inventoryId =
                                      option?.inventoryid || "---";
                                    return `${productLabel} | ${serialNo} | ${inventoryId}`;
                                  }}
                                  value={value || null}
                                  onChange={(event, newValue) => {
                                    onChange(newValue);
                                    handleSelection(newValue);
                                    if (newValue) {
                                      clearErrors(column.id);
                                    }
                                  }}
                                  filterOptions={(options, state) => {
                                    if (state.inputValue === "") {
                                      return options;
                                    }
                                    const filtered = options.filter(
                                      (option) =>
                                        option?.model
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ) ||
                                        option?.technical_details?.product_title
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ) ||
                                        option?.technical_details?.product_name
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ) ||
                                        option?.serialno
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ) ||
                                        option?.technical_details?.model_number
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ) ||
                                        String(option?.inventoryid)
                                          ?.toLowerCase()
                                          .includes(
                                            state.inputValue.toLowerCase(),
                                          ),
                                    );
                                    if (filtered.length === 0) {
                                      filtered.push({
                                        model:
                                          "Click here to create new Inventory item",
                                        isNew: true,
                                      });
                                    }
                                    return filtered;
                                  }}
                                  renderOption={(option) => {
                                    if (option.isNew) {
                                      return (
                                        <ListItem
                                          onClick={() =>
                                            history.push("/create-inventory")
                                          }
                                          component="a"
                                        >
                                          Click here to create new Inventory
                                          item
                                        </ListItem>
                                      );
                                    }

                                    const model = option?.model || "";
                                    const productTitle =
                                      option?.technical_details
                                        ?.product_title || "";
                                    const productName =
                                      option?.technical_details?.product_name ||
                                      "";
                                    const productLabel =
                                      model ||
                                      productTitle ||
                                      productName ||
                                      "---";
                                    const serialNo =
                                      option?.serialno ||
                                      option?.technical_details?.model_number ||
                                      "---";
                                    const inventoryId =
                                      option?.inventoryid || "---";
                                    return `${productLabel} | ${serialNo} | ${inventoryId}`;
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="standard"
                                      label="Search Model | Serial No | Inventory ID"
                                      InputLabelProps={{
                                        className:
                                          "MuiFormControlLabel-root contact-add-field",
                                      }}
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <>
                                            {params.InputProps.endAdornment}
                                            <InputAdornment position="end">
                                              <SearchIcon />
                                            </InputAdornment>
                                          </>
                                        ),
                                      }}
                                    />
                                  )}
                                />
                              )}
                            />
                          </FormControl>
                        </div>
                        {errors[column.id] && (
                          <span style={{ color: "red" }}>{column.errMsg}</span>
                        )}
                      </>
                    )}
                    {column.id === "modelNumber" && (
                      <>
                        <div className="searchInputs">
                          <FormControl className="form-width-100">
                            {modelNo ? (
                              <InputLabel
                                htmlFor="model"
                                shrink={true}
                                style={{ color: "#424242" }}
                              >
                                {column.label}
                              </InputLabel>
                            ) : (
                              <InputLabel
                                htmlFor="model"
                                shrink={false}
                                style={{ color: "#424242" }}
                              >
                                {column.label}
                              </InputLabel>
                            )}

                            <AntdInput
                              readOnly
                              id="model"
                              type="text"
                              autoComplete="off"
                              ref={modelinputRef}
                              value={modelNo}
                              {...register(column.id, {
                                required: column.required
                                  ? column.errMsg
                                  : false,
                              })}
                              onChange={(e) => {
                                handleSearch(e, column.id);
                              }}
                              style={{
                                marginBottom: "0px",
                                marginTop: "10px",
                                fontSize: "16px",
                              }}
                              bordered={false}
                            />
                            <Divider style={{ marginTop: "5px" }} />
                          </FormControl>
                          {/* <div className="searchIcon">
                            {!modelNo ? (
                              <SearchIcon />
                            ) : (
                              <CloseIcon
                                id="clearBtn"
                                onClick={clearSearchInput}
                              />
                            )}
                          </div> */}
                          {model &&
                            model.length > 0 &&
                            searchInputmodelno.length > 0 && (
                              <div
                                style={{
                                  marginLeft: "-360px",
                                  marginTop: "50px",
                                }}
                              >
                                <AntdPopover
                                  id="model"
                                  visible={isPopoverVisiblemodelno}
                                  onVisibleChange={setIsPopoverVisiblemodelno}
                                  content={
                                    <div
                                      style={{
                                        // height: "200px",
                                        overflow: "auto",
                                      }}
                                    >
                                      {model?.slice(0, 15).map((value) => (
                                        <Typography
                                          key={
                                            value.model && value.model !== null
                                              ? value.model
                                              : value.miscmodal
                                          }
                                          style={{ padding: 10, width: 200 }}
                                          onClick={() =>
                                            handleSelection(
                                              value,
                                              value.model &&
                                                value.model !== null
                                                ? "model"
                                                : "miscmodal",
                                            )
                                          }
                                        >
                                          {value.model && value.model !== null
                                            ? value.model
                                            : value?.technical_details
                                              ?.product_title
                                              ? value?.technical_details
                                                ?.product_title
                                              : value?.technical_details
                                                ?.product_name}
                                        </Typography>
                                      ))}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottom"
                                >
                                  <div
                                    style={{
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                </AntdPopover>
                              </div>
                            )}
                        </div>
                        {errors[column.id] && (
                          <span style={{ color: "red" }}>{column.errMsg}</span>
                        )}
                        {noData && currentSearch === "modelNumber" && (
                          <div className="dataResult">
                            <a
                              className="dataItem"
                              onClick={() => {
                                props.history.push("/create-inventory");
                              }}
                            >
                              Click here to create new Inventory item
                            </a>
                          </div>
                        )}
                      </>
                    )}
                    {column.id === "serialNumber" && (
                      <>
                        <div className="searchInputs">
                          <FormControl className="form-width-100">
                            {serial ? (
                              <InputLabel
                                htmlFor="model"
                                shrink={true}
                                style={{ color: "#424242" }}
                              >
                                {column.label}
                              </InputLabel>
                            ) : (
                              <InputLabel
                                htmlFor="model"
                                shrink={false}
                                style={{ color: "#424242" }}
                              >
                                {column.label}
                              </InputLabel>
                            )}

                            <AntdInput
                              readOnly
                              id="model"
                              type="text"
                              autoComplete="off"
                              value={serial}
                              ref={serialinputRef}
                              {...register(column.id, {
                                required:
                                  type !== "misc_product"
                                    ? column.required
                                      ? column.errMsg
                                      : false
                                    : false,
                              })}
                              onChange={(e) => {
                                handleSearch(e, column.id);
                              }}
                              style={{
                                marginBottom: "0px",
                                marginTop: "10px",
                                fontSize: "16px",
                              }}
                              bordered={false}
                            />
                            <Divider style={{ marginTop: "5px" }} />
                          </FormControl>
                          {/* <div className="searchIcon">
                            {!serial ? (
                              <SearchIcon />
                            ) : (
                              <CloseIcon
                                id="clearBtn"
                                onClick={clearSearchInput}
                              />
                            )}
                          </div> */}
                          {serialList &&
                            serialList.length > 0 &&
                            searchInputserialno.length > 0 && (
                              <div
                                style={{
                                  marginLeft: "-360px",
                                  marginTop: "50px",
                                }}
                              >
                                <AntdPopover
                                  id={column.id}
                                  visible={isPopoverVisibleserialno}
                                  onVisibleChange={setIsPopoverVisibleserialno}
                                  content={
                                    <div
                                      style={{
                                        height: "180px",
                                        overflow: "auto",
                                      }}
                                    >
                                      {serialList?.slice(0, 15).map((value) => {
                                        return (
                                          <Typography
                                            key={value}
                                            style={{ padding: 10, width: 200 }}
                                            onClick={() => {
                                              handleSelection(value, "serial");
                                            }}
                                          >
                                            {value["serialno"]}
                                          </Typography>
                                        );
                                      })}
                                    </div>
                                  }
                                  trigger="click"
                                  placement="bottom"
                                >
                                  <div
                                    style={{
                                      width: 0,
                                      height: 0,
                                      position: "absolute",
                                    }}
                                  />
                                </AntdPopover>
                              </div>
                            )}
                        </div>
                        {errors[column.id] ? (
                          <span style={{ color: "red" }}>{column.errMsg}</span>
                        ) : isSerialNumberRequired ? (
                          <span style={{ color: "red" }}>
                            {"Please Enter Serial No"}
                          </span>
                        ) : (
                          <></>
                        )}
                        {noData && currentSearch === "serialNumber" && (
                          <div className="dataResult">
                            <a
                              className="dataItem"
                              onClick={() => {
                                props.history.push("/create-inventory");
                              }}
                            >
                              Click here to create new Inventory item
                            </a>
                          </div>
                        )}
                      </>
                    )}
                    {column.id !== "action" &&
                      (column.type === "text" || column.type === "number") && (
                        <FormControl className="form-width-100 margin-t-b-20 margin-p-b-20">
                          {column.id === "quantity" ? (
                            <InputLabel
                              shrink={qtyShrink}
                              htmlFor="component-simple"
                              className="color-292C2F"
                            >
                              {column.label}
                            </InputLabel>
                          ) : column.id === "productName" ? (
                            <InputLabel
                              shrink={descShrink}
                              htmlFor="component-simple"
                              className="color-292C2F"
                            >
                              {column.label}
                            </InputLabel>
                          ) : (
                            <InputLabel
                              htmlFor="component-simple"
                              className="color-292C2F"
                            >
                              {column.label}
                            </InputLabel>
                          )}
                          <Input
                            id={column.id}
                            value={
                              column.id === "productName"
                                ? desc
                                : column.id === "quantity"
                                  ? quantity
                                  : 1
                            }
                            {...register(column.id, {
                              required: column.required ? column.errMsg : false,
                            })}
                            onChange={handleDescription}
                            inputProps={{
                              type: column.type,
                              autoComplete: "off",
                            }}
                            readOnly={column.id === "quantity" ? true : false}
                            disableUnderline={false}
                            disabled={
                              column.id === "productName" ? disabled : false
                            }
                          />
                          {errors[column.id] && (
                            <span style={{ color: "red" }}>
                              {column.errMsg}
                            </span>
                          )}
                        </FormControl>
                      )}
                    {(column.type === "select" || column.type === "amount") && (
                      <FormControl
                        className={`form-width-${column.minWidth} margin-t-b-20 margin-p-b-20`}
                        style={{
                          marginRight: column.type === "select" ? "16px" : 0,
                        }}
                      >
                        <InputLabel
                          htmlFor="component-simple"
                          className="color-292C2F"
                        >
                          {column.label}
                        </InputLabel>
                        {column.type === "select" ? (
                          <Select
                            labelId="demo-simple-select-outlined-label"
                            id="demo-simple-select-outlined"
                            // defaultValue={"USD"}
                            value={currency}
                            onChange={(e) => {
                              setCurrency(e.target.value);
                            }}
                          >
                            <MenuItem value="USD">USD</MenuItem>
                            <MenuItem value="HK$">HK$</MenuItem>
                            <MenuItem value="Euro">Euro</MenuItem>
                            <MenuItem value="AED">AED</MenuItem>
                          </Select>
                        ) : (
                          <Input
                            id="component-simple"
                            {...register(column.id, {
                              required: column.errMsg || true,
                            })}
                            inputProps={{
                              type: column.type,
                              maxLength: "15",
                              autoComplete: "off",
                            }}
                            disableUnderline={false}
                            value={amount}
                            onChange={(e) => {
                              const val = e.target.value.replace(
                                /[^0-9\.]/g,
                                "",
                              );
                              setAmount(val);
                              try {
                                setValue && setValue(column.id, val);
                              } catch (err) { }
                              if (val && val !== "") {
                                clearErrors && clearErrors(column.id);
                              } else {
                                setError &&
                                  setError(column.id, {
                                    type: "manual",
                                    message:
                                      column.errMsg || "Please Enter Amount",
                                  });
                              }
                            }}
                          />
                        )}
                        {errors[column.id] && (
                          <span style={{ color: "red" }}>{column.errMsg}</span>
                        )}
                      </FormControl>
                    )}
                  </>
                );
              })}
              <Box style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  type="submit"
                  variant="text"
                  style={{
                    background: !noData ? "#000" : "#cccc",
                    color: "#fff",
                    marginTop: "20px",
                    marginRight: "10px",
                  }}
                  disabled={noData}
                >
                  Submit
                </Button>
                &nbsp;
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  style={{
                    background: "#fff",
                    color: "#000",
                    marginTop: "20px",
                    paddingTop: "5 !important",
                    paddingBottom: "5 !important",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          </Box>
        </AntdModal>
        <AntdModal
          open={dealerPushConfirmOpen}
          footer={null}
          closable={false}
          centered
        >
          <Box style={{ padding: "10px 0" }}>
            <Typography variant="h6" component="h2" style={{ marginBottom: 16 }}>
              Push Inventory to Dealer?
            </Typography>
            <p style={{ marginBottom: 24, fontSize: 14, color: "#454545" }}>
              Since the customer is a registered WatchOps Dealer, would you like to push the inventory items from this invoice directly to the buyer's dealer account?
              <br />Note: <i>This inventory transfer cannot be reversed. Do you want to continue?</i>
            </p>
            <Box style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
              <Button
                variant="outlined"
                onClick={() => handleDealerPushDecision(false)}
                style={{ background: "#fff", color: "#000" }}
              >
                No
              </Button>
              <Button
                variant="text"
                onClick={() => handleDealerPushDecision(true)}
                style={{ background: "#000", color: "#fff" }}
              >
                Yes
              </Button>
            </Box>
          </Box>
        </AntdModal>
        {/* <>
        {openpricewarning && (
        <Pricewarining
          open={openpricewarning}
          handleClose={handleClosepriceModal}
        price={onSubmitone}
        />)}
        </> */}
      </Container>
      <FooterComponent />
      {contactListConfirmationModal && (
        <ContactListModal
          open={contactListConfirmationModal}
          close={handleCloseContactConfirmation}
          confirm={handleSuccessContactConfirmation}
          text={modalText}
        />
      )}
      <CreateContactDialog
        open={createContactModalOpen}
        onClose={() => setCreateContactModalOpen(false)}
        onSuccess={handleCreateContactSuccess}
      />
      {
        <InvoiceValidation
          open={saletaxOpen}
          handleClose={handleSalesTaxModalClose}
          handleNavigate={handleNavigate}
          handleFocus={handleFocus}
          errorCode={errorCode}
          errorMessage={errorMessage}
          handleCheckSalesID={handleSubmit1((data) =>
            onCreateInvoiceSubmit(data, false, true),
          )}
          handleCheckTotalAmount={handleSubmit1((data) =>
            onCreateInvoiceSubmit(data, false, false),
          )}
          reason={reason}
          setReason={setReason}
          salestaxSkipReason={salestaxSkipReason}
          setSalestaxSkipReason={setSalestaxSkipReason}
        />
      }
      {openQBOInvoiceModal && (
        <QboInvoice
          open={openQBOInvoiceModal}
          handleClose={handleCloseQBO}
          invoiceId={invoiceId}
          accountId={accountId}
        // inventory={selectedInventory}
        // onSubmitSuccess={openVoidAfterExpense}
        />
      )}
    </div>
  );
}

function mapStateToProps({
  auth,
  InvoiceDetails,
  ModelList,
  BillShipCntctLst,
  DataTransferBusinessList,
}) {
  return {
    invoiceDetails: InvoiceDetails.invoiceDetails,
    currentUser: auth.currentUser,
    modelList: ModelList.modelList,
    billShipCntctLst: BillShipCntctLst.billShipCntctLst,
    dealerBusinessList:
      DataTransferBusinessList?.DataTransferBusinessList?.dataTransferBusinessList ||
      DataTransferBusinessList?.dataTransferBusinessList ||
      (Array.isArray(DataTransferBusinessList) ? DataTransferBusinessList : []),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createInvoiceDetails,
      getModelSerialList,
      getNewModelSerialList,
      checkContactInDB,
      getBillShipContactList,
      getInvoiceNewContactList,
      getMemoList,
      dataTransferBusinessList,
      invoiceDataPush,
    },
    dispatch,
  );
}

CreateInvoiceComponent.propTypes = {
  modelList: PropTypes.arrayOf(PropTypes.object).isRequired,
  getModelSerialList: PropTypes.func.isRequired,
  getNewModelSerialList: PropTypes.func.isRequired,
  getBillShipContactList: PropTypes.func.isRequired,
  getInvoiceNewContactList: PropTypes.func.isRequired,
  getMemoList: PropTypes.func.isRequired,
  dataTransferBusinessList: PropTypes.func.isRequired,
  invoiceDataPush: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateInvoiceComponent);